import blackTeeFront from '../clothing/man/top/black 1c1919/default tee front.png'
import blueTeeFront from '../clothing/man/top/blue 0091e5/default tee front.png'
import cyanTeeFront from '../clothing/man/top/cyan 00d2ff/default tee front.png'
import greenTeeFront from '../clothing/man/top/green 72ff00/default tee front.png'
import orangeTeeFront from '../clothing/man/top/orange fd6500/default tee front.png'
import pinkTeeFront from '../clothing/man/top/pink ff00f0/default tee front.png'
import purpleTeeFront from '../clothing/man/top/purple a200ff/default tee front.png'
import redTeeFront from '../clothing/man/top/red ea0000/default tee front.png'
import turqoiseTeeFront from '../clothing/man/top/turqoise 00ffd8/default tee front.png'
import whiteTeeFront from '../clothing/man/top/white fff/default tee front.png'
import yellowTeeFront from '../clothing/man/top/yellow fff600/default tee front.png'


import blackTeeBack from '../clothing/man/top/black 1c1919/default tee back.png'
import blueTeeBack from '../clothing/man/top/blue 0091e5/default tee back.png'
import cyanTeeBack from '../clothing/man/top/cyan 00d2ff/default tee back.png'
import greenTeeBack from '../clothing/man/top/green 72ff00/default tee back.png'
import orangeTeeBack from '../clothing/man/top/orange fd6500/default tee back.png'
import pinkTeeBack from '../clothing/man/top/pink ff00f0/default tee back.png'
import purpleTeeBack from '../clothing/man/top/purple a200ff/default tee back.png'
import redTeeBack from '../clothing/man/top/red ea0000/default tee back.png'
import turqoiseTeeBack from '../clothing/man/top/turqoise 00ffd8/default tee back.png'
import whiteTeeBack from '../clothing/man/top/white fff/default tee back.png'
import yellowTeeBack from '../clothing/man/top/yellow fff600/default tee back.png'

import blueHooFrontPatern from '../clothing/man/top/pattern/frontBlue.png'
import blueHooBackPatern from '../clothing/man/top/pattern/backBlue.png'
import blueHooLeftPatern from '../clothing/man/top/pattern/leftBlue.png'
import blueHooRightPatern from '../clothing/man/top/pattern/rightBlue.png'

import redHooFrontPatern from '../clothing/man/top/pattern/frontRed.png'
import redHooBackPatern from '../clothing/man/top/pattern/backRed.png'
import redHooLeftPatern from '../clothing/man/top/pattern/leftRed.png'
import redHooRightPatern from '../clothing/man/top/pattern/rightRed.png'

import yellowHooFrontPatern from '../clothing/man/top/pattern/frontYellow.png'
import yellowHooBackPatern from '../clothing/man/top/pattern/backYellow.png'
import yellowHooLeftPatern from '../clothing/man/top/pattern/leftYellow.png'
import yellowHooRightPatern from '../clothing/man/top/pattern/rightYellow.png'

import whiteHooFrontPatern from '../clothing/man/top/pattern/frontWhite.png'
import whiteHooBackPatern from '../clothing/man/top/pattern/backWhite.png'
import whiteHooLeftPatern from '../clothing/man/top/pattern/leftWhite.png'
import whiteHooRightPatern from '../clothing/man/top/pattern/rightWhite.png'

import greenHooFrontPatern from '../clothing/man/top/pattern/frontGreen.png'
import greenHooBackPatern from '../clothing/man/top/pattern/backGreen.png'
import greenHooLeftPatern from '../clothing/man/top/pattern/leftGreen.png'
import greenHooRightPatern from '../clothing/man/top/pattern/rightGreen.png'

import sprayHooFrontCustom from '../clothing/man/top/custom/frontSpray.png'
import sprayHooBackCustom from '../clothing/man/top/custom/backSpray.png'
import sprayHooLeftCustom from '../clothing/man/top/custom/leftSpray.png'
import sprayHooRightCustom from '../clothing/man/top/custom/rightSpray.png'

import bascketHooFrontCustom from '../clothing/man/top/custom/frontBascket.png'
import bascketHooBackCustom from '../clothing/man/top/custom/backBascket.png'
import bascketHooLeftCustom from '../clothing/man/top/custom/leftBascket.png'
import bascketHooRightCustom from '../clothing/man/top/custom/rightBascket.png'

import shapeHooFrontCustom from '../clothing/man/top/custom/frontShape.png'
import shapeHooBackCustom from '../clothing/man/top/custom/backShape.png'
import shapeHooLeftCustom from '../clothing/man/top/custom/leftShape.png'
import shapeHooRightCustom from '../clothing/man/top/custom/rightShape.png'

import snakeHooFrontCustom from '../clothing/man/top/custom/frontSnake.png'
import snakeHooBackCustom from '../clothing/man/top/custom/backSnake.png'
import snakeHooLeftCustom from '../clothing/man/top/custom/leftSnake.png'
import snakeHooRightCustom from '../clothing/man/top/custom/rightSnake.png'

import blueHooFront from '../clothing/man/top/blue 0091e5/default hoo front.png'
import blueHooBack from '../clothing/man/top/blue 0091e5/default hoo back.png'
import blueHooRight from '../clothing/man/top/blue 0091e5/default hoo right.png'
import blueHooLeft from '../clothing/man/top/blue 0091e5/default hoo left.png'

import cyanHooFront from '../clothing/man/top/cyan 00d2ff/default hoo front.png'
import cyanHooBack from '../clothing/man/top/cyan 00d2ff/default hoo back.png'
import cyanHooRight from '../clothing/man/top/cyan 00d2ff/default hoo right.png'
import cyanHooLeft from '../clothing/man/top/cyan 00d2ff/default hoo left.png'

import greenHooFront from '../clothing/man/top/green 72ff00/default hoo front.png'
import greenHooBack from '../clothing/man/top/green 72ff00/default hoo back.png'
import greenHooRight from '../clothing/man/top/green 72ff00/default hoo right.png'
import greenHooLeft from '../clothing/man/top/green 72ff00/default hoo left.png'

import orangeHooFront from '../clothing/man/top/orange fd6500/default hoo front.png'
import orangeHooBack from '../clothing/man/top/orange fd6500/default hoo back.png'
import orangeHooRight from '../clothing/man/top/orange fd6500/default hoo right.png'
import orangeHooLeft from '../clothing/man/top/orange fd6500/default hoo left.png'

import pinkHooFront from '../clothing/man/top/pink ff00f0/default hoo front.png'
import pinkHooBack from '../clothing/man/top/pink ff00f0/default hoo back.png'
import pinkHooRight from '../clothing/man/top/pink ff00f0/default hoo right.png'
import pinkHooLeft from '../clothing/man/top/pink ff00f0/default hoo left.png'

import purpleHooFront from '../clothing/man/top/purple a200ff/default hoo front.png'
import purpleHooBack from '../clothing/man/top/purple a200ff/default hoo back.png'
import purpleHooRight from '../clothing/man/top/purple a200ff/default hoo right.png'
import purpleHooLeft from '../clothing/man/top/purple a200ff/default hoo left.png'

import redHooFront from '../clothing/man/top/red ea0000/default hoo front.png'
import redHooBack from '../clothing/man/top/red ea0000/default hoo back.png'
import redHooRight from '../clothing/man/top/red ea0000/default hoo right.png'
import redHooLeft from '../clothing/man/top/red ea0000/default hoo left.png'

import turqoiseHooFront from '../clothing/man/top/turqoise 00ffd8/default hoo front.png'
import turqoiseHooBack from '../clothing/man/top/turqoise 00ffd8/default hoo back.png'
import turqoiseHooRight from '../clothing/man/top/turqoise 00ffd8/default hoo right.png'
import turqoiseHooLeft from '../clothing/man/top/turqoise 00ffd8/default hoo left.png'

import blackHooFront from '../clothing/man/top/black 1c1919/default hoo front.png'
import blackHooBack from '../clothing/man/top/black 1c1919/default hoo back.png'
import blackHooRight from '../clothing/man/top/black 1c1919/default hoo right.png'
import blackHooLeft from '../clothing/man/top/black 1c1919/default hoo left.png'

import yellowHooFront from '../clothing/man/top/yellow fff600/default hoo front.png'
import yellowHooBack from '../clothing/man/top/yellow fff600/default hoo back.png'
import yellowHooRight from '../clothing/man/top/yellow fff600/default hoo right.png'
import yellowHooLeft from '../clothing/man/top/yellow fff600/default hoo left.png'

/*----------Shirt----------*/

/*Layout*/

import manLayoutShiBack from '../clothing/man/top/layout/default back.png'
import manLayoutShiLeft from '../clothing/man/top/layout/default left.png'
import manLayoutShiRight from '../clothing/man/top/layout/default right.png'


import manDefaultblackShiFront from '../clothing/man/top/black 1c1919/default shi front.png'
import manDefaultblueShiFront from '../clothing/man/top/blue 0091e5/default shi front.png'
import manDefaultcyanShiFront from '../clothing/man/top/cyan 00d2ff/default shi front.png'
import manDefaultgreenShiFront from '../clothing/man/top/green 72ff00/default shi front.png'
import manDefaultorangeShiFront from '../clothing/man/top/orange fd6500/default shi front.png'
import manDefaultpinkShiFront from '../clothing/man/top/pink ff00f0/default shi front.png'
import manDefaultpurpleShiFront from '../clothing/man/top/purple a200ff/default shi front.png'
import manDefaultredShiFront from '../clothing/man/top/red ea0000/default shi front.png'
import manDefaultturqoiseShiFront from '../clothing/man/top/turqoise 00ffd8/default shi front.png'
import manDefaultyellowShiFront from '../clothing/man/top/yellow fff600/default shi front.png'


import manSnakeblackShiFront from '../clothing/man/top/black 1c1919/snake shi front.png'
import manSnakeblueShiFront from '../clothing/man/top/blue 0091e5/snake shi front.png'
import manSnakecyanShiFront from '../clothing/man/top/cyan 00d2ff/snake shi front.png'
import manSnakegreenShiFront from '../clothing/man/top/green 72ff00/snake shi front.png'
import manSnakeorangeShiFront from '../clothing/man/top/orange fd6500/snake shi front.png'
import manSnakepinkShiFront from '../clothing/man/top/pink ff00f0/snake shi front.png'
import manSnakepurpleShiFront from '../clothing/man/top/purple a200ff/snake shi front.png'
import manSnakeredShiFront from '../clothing/man/top/red ea0000/snake shi front.png'
import manSnaketurqoiseShiFront from '../clothing/man/top/turqoise 00ffd8/snake shi front.png'
import manSnakeyellowShiFront from '../clothing/man/top/yellow fff600/snake shi front.png'



/*----------Pants----------*/



import manLayoutPanBrownBack from '../clothing/man/bottom/layout/default pan brown back.png'
import manLayoutPanGreyBack from '../clothing/man/bottom/layout/default pan grey back.png'
import manLayoutPanRedBack from '../clothing/man/bottom/layout/default pan red back.png'
import manLayoutPanOrangeBack from '../clothing/man/bottom/layout/default pan orange back.png'

import manblackPanBrownFront from '../clothing/man/bottom/black 1c1919/default pan brown front.png'

import manbluePanBrownFront from '../clothing/man/bottom/blue 0091e5/default pan brown front.png'

import mancyanPanBrownFront from '../clothing/man/bottom/cyan 00d2ff/default pan brown front.png'

import mangreenPanBrownFront from '../clothing/man/bottom/green 72ff00/default pan brown front.png'

import manorangePanBrownFront from '../clothing/man/bottom/orange fd6500/default pan brown front.png'

import manpinkPanBrownFront from '../clothing/man/bottom/pink ff00f0/default pan brown front.png'

import manpurplePanBrownFront from '../clothing/man/bottom/purple a200ff/default pan brown front.png'

import manredPanBrownFront from '../clothing/man/bottom/red ea0000/default pan brown front.png'

import manturqoisePanBrownFront from '../clothing/man/bottom/turqoise 00ffd8/default pan brown front.png'

import manwhitePanBrownFront from '../clothing/man/bottom/white fff/default pan brown front.png'

import manyellowPanBrownFront from '../clothing/man/bottom/yellow fff600/default pan brown front.png'


/*Grey*/


import manblackPanGreyFront from '../clothing/man/bottom/black 1c1919/default pan grey front.png'

import manbluePanGreyFront from '../clothing/man/bottom/blue 0091e5/default pan grey front.png'

import mancyanPanGreyFront from '../clothing/man/bottom/cyan 00d2ff/default pan grey front.png'

import mangreenPanGreyFront from '../clothing/man/bottom/green 72ff00/default pan grey front.png'

import manorangePanGreyFront from '../clothing/man/bottom/orange fd6500/default pan grey front.png'

import manpinkPanGreyFront from '../clothing/man/bottom/pink ff00f0/default pan grey front.png'

import manpurplePanGreyFront from '../clothing/man/bottom/purple a200ff/default pan grey front.png'

import manredPanGreyFront from '../clothing/man/bottom/red ea0000/default pan grey front.png'

import manturqoisePanGreyFront from '../clothing/man/bottom/turqoise 00ffd8/default pan grey front.png'

import manwhitePanGreyFront from '../clothing/man/bottom/white fff/default pan grey front.png'

import manyellowPanGreyFront from '../clothing/man/bottom/yellow fff600/default pan grey front.png'


/*----------Red----------*/


import manblackPanRedFront from '../clothing/man/bottom/black 1c1919/default pan red front.png'

import manbluePanRedFront from '../clothing/man/bottom/blue 0091e5/default pan red front.png'

import mancyanPanRedFront from '../clothing/man/bottom/cyan 00d2ff/default pan red front.png'

import mangreenPanRedFront from '../clothing/man/bottom/green 72ff00/default pan red front.png'

import manorangePanRedFront from '../clothing/man/bottom/orange fd6500/default pan red front.png'

import manpinkPanRedFront from '../clothing/man/bottom/pink ff00f0/default pan red front.png'

import manpurplePanRedFront from '../clothing/man/bottom/purple a200ff/default pan red front.png'

import manredPanRedFront from '../clothing/man/bottom/red ea0000/default pan red front.png'

import manturqoisePanRedFront from '../clothing/man/bottom/turqoise 00ffd8/default pan red front.png'

import manwhitePanRedFront from '../clothing/man/bottom/white fff/default pan red front.png'

import manyellowPanRedFront from '../clothing/man/bottom/yellow fff600/default pan red front.png'


/*----------Orange---------*/

import manblackPanOrangeFront from '../clothing/man/bottom/black 1c1919/default pan orange front.png'

import manbluePanOrangeFront from '../clothing/man/bottom/blue 0091e5/default pan orange front.png'

import mancyanPanOrangeFront from '../clothing/man/bottom/cyan 00d2ff/default pan orange front.png'

import mangreenPanOrangeFront from '../clothing/man/bottom/green 72ff00/default pan orange front.png'

import manorangePanOrangeFront from '../clothing/man/bottom/orange fd6500/default pan orange front.png'

import manpinkPanOrangeFront from '../clothing/man/bottom/pink ff00f0/default pan orange front.png'

import manpurplePanOrangeFront from '../clothing/man/bottom/purple a200ff/default pan orange front.png'

import manredPanOrangeFront from '../clothing/man/bottom/red ea0000/default pan orange front.png'

import manturqoisePanOrangeFront from '../clothing/man/bottom/turqoise 00ffd8/default pan orange front.png'

import manwhitePanOrangeFront from '../clothing/man/bottom/white fff/default pan orange front.png'

import manyellowPanOrangeFront from '../clothing/man/bottom/yellow fff600/default pan orange front.png'


/*Snake edition*/
/*----------BrownSnake---------*/

import manSnakeblackPanBrownFront from '../clothing/man/bottom/black 1c1919/snake pan brown front.png'

import manSnakebluePanBrownFront from '../clothing/man/bottom/blue 0091e5/snake pan brown front.png'

import manSnakecyanPanBrownFront from '../clothing/man/bottom/cyan 00d2ff/snake pan brown front.png'

import manSnakegreenPanBrownFront from '../clothing/man/bottom/green 72ff00/snake pan brown front.png'

import manSnakeorangePanBrownFront from '../clothing/man/bottom/orange fd6500/snake pan brown front.png'

import manSnakepinkPanBrownFront from '../clothing/man/bottom/pink ff00f0/snake pan brown front.png'

import manSnakepurplePanBrownFront from '../clothing/man/bottom/purple a200ff/snake pan brown front.png'

import manSnakeredPanBrownFront from '../clothing/man/bottom/red ea0000/snake pan brown front.png'

import manSnaketurqoisePanBrownFront from '../clothing/man/bottom/turqoise 00ffd8/snake pan brown front.png'

import manSnakewhitePanBrownFront from '../clothing/man/bottom/white fff/snake pan brown front.png'

import manSnakeyellowPanBrownFront from '../clothing/man/bottom/yellow fff600/snake pan brown front.png'


/*----------GreySnake----------*/


import manSnakeblackPanGreyFront from '../clothing/man/bottom/black 1c1919/snake pan grey front.png'

import manSnakebluePanGreyFront from '../clothing/man/bottom/blue 0091e5/snake pan grey front.png'

import manSnakecyanPanGreyFront from '../clothing/man/bottom/cyan 00d2ff/snake pan grey front.png'

import manSnakegreenPanGreyFront from '../clothing/man/bottom/green 72ff00/snake pan grey front.png'

import manSnakeorangePanGreyFront from '../clothing/man/bottom/orange fd6500/snake pan grey front.png'

import manSnakepinkPanGreyFront from '../clothing/man/bottom/pink ff00f0/snake pan grey front.png'

import manSnakepurplePanGreyFront from '../clothing/man/bottom/purple a200ff/snake pan grey front.png'

import manSnakeredPanGreyFront from '../clothing/man/bottom/red ea0000/snake pan grey front.png'

import manSnaketurqoisePanGreyFront from '../clothing/man/bottom/turqoise 00ffd8/snake pan grey front.png'

import manSnakewhitePanGreyFront from '../clothing/man/bottom/white fff/snake pan grey front.png'

import manSnakeyellowPanGreyFront from '../clothing/man/bottom/yellow fff600/snake pan grey front.png'


/*----------RedSnake----------*/


import manSnakeblackPanRedFront from '../clothing/man/bottom/black 1c1919/snake pan red front.png'

import manSnakebluePanRedFront from '../clothing/man/bottom/blue 0091e5/snake pan red front.png'

import manSnakecyanPanRedFront from '../clothing/man/bottom/cyan 00d2ff/snake pan red front.png'

import manSnakegreenPanRedFront from '../clothing/man/bottom/green 72ff00/snake pan red front.png'

import manSnakeorangePanRedFront from '../clothing/man/bottom/orange fd6500/snake pan red front.png'

import manSnakepinkPanRedFront from '../clothing/man/bottom/pink ff00f0/snake pan red front.png'

import manSnakepurplePanRedFront from '../clothing/man/bottom/purple a200ff/snake pan red front.png'

import manSnakeredPanRedFront from '../clothing/man/bottom/red ea0000/snake pan red front.png'

import manSnaketurqoisePanRedFront from '../clothing/man/bottom/turqoise 00ffd8/snake pan red front.png'

import manSnakewhitePanRedFront from '../clothing/man/bottom/white fff/snake pan red front.png'

import manSnakeyellowPanRedFront from '../clothing/man/bottom/yellow fff600/snake pan red front.png'


/*----------OrangeSnake---------*/

import manSnakeblackPanOrangeFront from '../clothing/man/bottom/black 1c1919/snake pan orange front.png'

import manSnakebluePanOrangeFront from '../clothing/man/bottom/blue 0091e5/snake pan orange front.png'

import manSnakecyanPanOrangeFront from '../clothing/man/bottom/cyan 00d2ff/snake pan orange front.png'

import manSnakegreenPanOrangeFront from '../clothing/man/bottom/green 72ff00/snake pan orange front.png'

import manSnakeorangePanOrangeFront from '../clothing/man/bottom/orange fd6500/snake pan orange front.png'

import manSnakepinkPanOrangeFront from '../clothing/man/bottom/pink ff00f0/snake pan orange front.png'

import manSnakepurplePanOrangeFront from '../clothing/man/bottom/purple a200ff/snake pan orange front.png'

import manSnakeredPanOrangeFront from '../clothing/man/bottom/red ea0000/snake pan orange front.png'

import manSnaketurqoisePanOrangeFront from '../clothing/man/bottom/turqoise 00ffd8/snake pan orange front.png'

import manSnakewhitePanOrangeFront from '../clothing/man/bottom/white fff/snake pan orange front.png'

import manSnakeyellowPanOrangeFront from '../clothing/man/bottom/yellow fff600/snake pan orange front.png'


/*----------Shorts----------*/

/*Layout*/

import manLayoutShoBack from '../clothing/man/bottom/layout/default sho back.png'
import manLayoutShoLeft from '../clothing/man/bottom/layout/default sho left.png'
import manLayoutShoRight from '../clothing/man/bottom/layout/default sho right.png'


import manblackShoFront from '../clothing/man/bottom/black 1c1919/default sho front.png'
import manblueShoFront from '../clothing/man/bottom/blue 0091e5/default sho front.png'
import mancyanShoFront from '../clothing/man/bottom/cyan 00d2ff/default sho front.png'
import mangreenShoFront from '../clothing/man/bottom/green 72ff00/default sho front.png'
import manorangeShoFront from '../clothing/man/bottom/orange fd6500/default sho front.png'
import manpinkShoFront from '../clothing/man/bottom/pink ff00f0/default sho front.png'
import manpurpleShoFront from '../clothing/man/bottom/purple a200ff/default sho front.png'
import manredShoFront from '../clothing/man/bottom/red ea0000/default sho front.png'
import manturqoiseShoFront from '../clothing/man/bottom/turqoise 00ffd8/default sho front.png'
import manyellowShoFront from '../clothing/man/bottom/yellow fff600/default sho front.png'

/*Pattern*/

import manPatternShoRedFront from '../clothing/man/bottom/pattern/red sho front.png'
import manPatternShoRedBack from '../clothing/man/bottom/pattern/red sho back.png'
import manPatternShoRedLeft from '../clothing/man/bottom/pattern/red sho left.png'
import manPatternShoRedRight from '../clothing/man/bottom/pattern/red sho right.png'

import manPatternShoWhiteFront from '../clothing/man/bottom/pattern/white sho front.png'
import manPatternShoWhiteBack from '../clothing/man/bottom/pattern/white sho back.png'
import manPatternShoWhiteLeft from '../clothing/man/bottom/pattern/white sho left.png'
import manPatternShoWhiteRight from '../clothing/man/bottom/pattern/white sho right.png'



/*===================WOMAN====================*/

/*----------Tee----------*/

/*Layout*/

import womanLayoutTeeBack from '../clothing/woman/top/layout/default tee back.png'
import womanLayoutTeeLeft from '../clothing/woman/top/layout/default tee left.png'
import womanLayoutTeeRight from '../clothing/woman/top/layout/default tee right.png'


import womanblackTeeFront from '../clothing/woman/top/black 1c1919/default tee front.png'
import womanblueTeeFront from '../clothing/woman/top/blue 0091e5/default tee front.png'
import womancyanTeeFront from '../clothing/woman/top/cyan 00d2ff/default tee front.png'
import womangreenTeeFront from '../clothing/woman/top/green 72ff00/default tee front.png'
import womanorangeTeeFront from '../clothing/woman/top/orange fd6500/default tee front.png'
import womanpinkTeeFront from '../clothing/woman/top/pink ff00f0/default tee front.png'
import womanpurpleTeeFront from '../clothing/woman/top/purple a200ff/default tee front.png'
import womanredTeeFront from '../clothing/woman/top/red ea0000/default tee front.png'
import womanturqoiseTeeFront from '../clothing/woman/top/turqoise 00ffd8/default tee front.png'
import womanyellowTeeFront from '../clothing/woman/top/yellow fff600/default tee front.png'

/*Pattern*/

import womanPatternTeeRedFront from '../clothing/woman/top/pattern/red tee front.png'
import womanPatternTeeRedBack from '../clothing/woman/top/pattern/red tee back.png'
import womanPatternTeeRedLeft from '../clothing/woman/top/pattern/red tee left.png'
import womanPatternTeeRedRight from '../clothing/woman/top/pattern/red tee right.png'

import womanPatternTeeWhiteFront from '../clothing/woman/top/pattern/white tee front.png'
import womanPatternTeeWhiteBack from '../clothing/woman/top/pattern/white tee back.png'
import womanPatternTeeWhiteLeft from '../clothing/woman/top/pattern/white tee left.png'
import womanPatternTeeWhiteRight from '../clothing/woman/top/pattern/white tee right.png'

import womanPatternTeeYellowFront from '../clothing/woman/top/pattern/yellow tee front.png'
import womanPatternTeeYellowBack from '../clothing/woman/top/pattern/yellow tee back.png'
import womanPatternTeeYellowLeft from '../clothing/woman/top/pattern/yellow tee left.png'
import womanPatternTeeYellowRight from '../clothing/woman/top/pattern/yellow tee right.png'

/*Layout*/

import womanLayoutTanBack from '../clothing/woman/top/layout/default tan back.png'
import womanLayoutTanLeft from '../clothing/woman/top/layout/default tan left.png'
import womanLayoutTanRight from '../clothing/woman/top/layout/default tan right.png'

import womanblackTanFront from '../clothing/woman/top/black 1c1919/default tan front.png'
import womanblueTanFront from '../clothing/woman/top/blue 0091e5/default tan front.png'
import womancyanTanFront from '../clothing/woman/top/cyan 00d2ff/default tan front.png'
import womangreenTanFront from '../clothing/woman/top/green 72ff00/default tan front.png'
import womanorangeTanFront from '../clothing/woman/top/orange fd6500/default tan front.png'
import womanpinkTanFront from '../clothing/woman/top/pink ff00f0/default tan front.png'
import womanpurpleTanFront from '../clothing/woman/top/purple a200ff/default tan front.png'
import womanredTanFront from '../clothing/woman/top/red ea0000/default tan front.png'
import womanturqoiseTanFront from '../clothing/woman/top/turqoise 00ffd8/default tan front.png'
import womanyellowTanFront from '../clothing/woman/top/yellow fff600/default tan front.png'


import womanSnakeblackTeeFront from '../clothing/woman/top/black 1c1919/snake tee front.png'
import womanSnakeblackTeeRight from '../clothing/woman/top/black 1c1919/snake tee right.png'
import womanSnakeblackTeeLeft from '../clothing/woman/top/black 1c1919/snake tee left.png'

import womanSnakeblueTeeFront from '../clothing/woman/top/blue 0091e5/snake tee front.png'
import womanSnakeblueTeeRight from '../clothing/woman/top/blue 0091e5/snake tee right.png'
import womanSnakeblueTeeLeft from '../clothing/woman/top/blue 0091e5/snake tee left.png'

import womanSnakecyanTeeFront from '../clothing/woman/top/cyan 00d2ff/snake tee front.png'
import womanSnakecyanTeeRight from '../clothing/woman/top/cyan 00d2ff/snake tee right.png'
import womanSnakecyanTeeLeft from '../clothing/woman/top/cyan 00d2ff/snake tee left.png'

import womanSnakegreenTeeFront from '../clothing/woman/top/green 72ff00/snake tee front.png'
import womanSnakegreenTeeRight from '../clothing/woman/top/green 72ff00/snake tee right.png'
import womanSnakegreenTeeLeft from '../clothing/woman/top/green 72ff00/snake tee left.png'

import womanSnakeorangeTeeFront from '../clothing/woman/top/orange fd6500/snake tee front.png'
import womanSnakeorangeTeeRight from '../clothing/woman/top/orange fd6500/snake tee right.png'
import womanSnakeorangeTeeLeft from '../clothing/woman/top/orange fd6500/snake tee left.png'

import womanSnakepinkTeeFront from '../clothing/woman/top/pink ff00f0/snake tee front.png'
import womanSnakepinkTeeRight from '../clothing/woman/top/pink ff00f0/snake tee right.png'
import womanSnakepinkTeeLeft from '../clothing/woman/top/pink ff00f0/snake tee left.png'

import womanSnakepurpleTeeFront from '../clothing/woman/top/purple a200ff/snake tee front.png'
import womanSnakepurpleTeeRight from '../clothing/woman/top/purple a200ff/snake tee right.png'
import womanSnakepurpleTeeLeft from '../clothing/woman/top/purple a200ff/snake tee left.png'

import womanSnakeredTeeFront from '../clothing/woman/top/red ea0000/snake tee front.png'
import womanSnakeredTeeRight from '../clothing/woman/top/red ea0000/snake tee right.png'
import womanSnakeredTeeLeft from '../clothing/woman/top/red ea0000/snake tee left.png'

import womanSnaketurqoiseTeeFront from '../clothing/woman/top/turqoise 00ffd8/snake tee front.png'
import womanSnaketurqoiseTeeRight from '../clothing/woman/top/turqoise 00ffd8/snake tee right.png'
import womanSnaketurqoiseTeeLeft from '../clothing/woman/top/turqoise 00ffd8/snake tee left.png'


import womanSnakeyellowTeeFront from '../clothing/woman/top/yellow fff600/snake tee front.png'
import womanSnakeyellowTeeRight from '../clothing/woman/top/yellow fff600/snake tee front.png'
import womanSnakeyellowTeeLeft from '../clothing/woman/top/yellow fff600/snake tee front.png'

/*----------FootWear----------*/

import manShoblueFront from '../clothing/man/foot/blue 0091e5/default sho.png'
import manShogreenFront from '../clothing/man/foot/green 72ff00/default sho.png'
import manShoorangeFront from '../clothing/man/foot/orange fd6500/default sho.png'
import manShopinkFront from '../clothing/man/foot/pink ff00f0/default sho.png'
import manShoredFront from '../clothing/man/foot/red ea0000/default sho.png'
import manShowhiteFront from '../clothing/man/foot/white fff/default sho.png'
import manShoyellowFront from '../clothing/man/foot/yellow fff600/default sho.png'



import womanShoblueFront from '../clothing/man/foot/blue 0091e5/default sho.png'
import womanShogreenFront from '../clothing/man/foot/green 72ff00/default sho.png'
import womanShoorangeFront from '../clothing/man/foot/orange fd6500/default sho.png'
import womanShopinkFront from '../clothing/man/foot/pink ff00f0/default sho.png'
import womanShoredFront from '../clothing/man/foot/red ea0000/default sho.png'
import womanShowhiteFront from '../clothing/woman/foot/white fff/default sho.png'
import womanShoyellowFront from '../clothing/man/foot/yellow fff600/default sho.png'


import manSliwhiteFront from '../clothing/man/foot/white fff/default sli.png'


import womanSliwhiteFront from '../clothing/woman/foot/white fff/default sli.png'




/*----------Collection----------*/

import womanCollectionOniFront1 from '../clothing/collections/oni mask 1.png'
import womanCollectionOniFront2 from '../clothing/collections/oni mask 2.png'


export const Product = {
  mtd1: {
    name: 'Tricou simplu',
    price: 29.99,
    discount: 0.2,
    photo: blackTeeFront,
    sliderPhoto: [blackTeeBack],
    sex: 'man',
    type: 'barbati top tricouri',
    colors: ['#1c1919', '#eee'],
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    star: { total: 0, nr: 0 },
    size: { XS: 20, S: 0, M: 4, L: 9, XL: 1, XXL: 4 },
    id: 'mtd1'
  }, mtd2: {
    name: 'Tricou simplu',
    price: 29.99,
    discount: 0.4,
    photo: blueTeeFront,
    sliderPhoto: [blueTeeBack],
    sex: 'man',
    type: 'barbati top tricouri',
    colors: ['#0091e5', '#eee'],
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    star: { total: 0, nr: 0 },
    size: { XS: 4, S: 0, M: 5, L: 10, XL: 2, XXL: 5 },
    id: 'mtd2'
  }, mtd3: {
    name: 'Tricou simplu',
    price: 79.99,
    discount: 0,
    photo: cyanTeeFront,
    sliderPhoto: [cyanTeeBack],
    sex: 'man',
    type: 'barbati top tricouri',
    colors: ['#00d2ff', '#eee'],
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    star: { total: 0, nr: 0 },
    size: { XS: 10, S: 5, M: 0, L: 9, XL: 0, XXL: 4 },
    id: 'mtd3'
  }, mtd4: {
    name: 'Tricou simplu',
    price: 149.99,
    discount: 0.5,
    photo: greenTeeFront,
    sliderPhoto: [greenTeeBack],
    sex: 'man',
    type: 'barbati top tricouri',
    colors: ['#72ff00', '#eee'],
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    star: { total: 0, nr: 0 },
    size: { XS: 10, S: 5, M: 4, L: 9, XL: 1, XXL: 4 },
    id: 'mtd4'
  }, mtd5: {
    name: 'Tricou simplu',
    price: 99.99,
    discount: 0.1,
    photo: orangeTeeFront,
    sliderPhoto: [orangeTeeBack],
    sex: 'man',
    type: 'barbati top tricouri',
    colors: ['#fd6500', '#eee'],
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    star: { total: 0, nr: 0 },
    size: { XS: 10, S: 0, M: 4, L: 9, XL: 1, XXL: 4 },
    id: 'mtd5'
  }, mtd6: {
    name: 'Tricou simplu',
    price: 129.99,
    discount: 0,
    photo: pinkTeeFront,
    sliderPhoto: [pinkTeeBack],
    sex: 'man',
    type: 'barbati top tricouri',
    colors: ['#ff00f0', '#eee'],
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    star: { total: 0, nr: 0 },
    size: { XS: 10, S: 5, M: 0, L: 0, XL: 1, XXL: 4 },
    id: 'mtd6'
  }, mtd7: {
    name: 'Tricou simplu',
    price: 89.99,
    discount: 0,
    photo: purpleTeeFront,
    sliderPhoto: [purpleTeeBack],
    sex: 'man',
    type: 'barbati top tricouri',
    colors: ['#a200ff', '#eee'],
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    star: { total: 0, nr: 0 },
    size: { XS: 0, S: 5, M: 4, L: 9, XL: 1, XXL: 4 },
    id: 'mtd7'
  }, mtd8: {
    name: 'Tricou simplu',
    price: 49.99,
    discount: 0,
    photo: redTeeFront,
    sliderPhoto: [redTeeBack],
    sex: 'man',
    type: 'barbati top tricouri',
    colors: ['#ea0000', '#eee'],
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    star: { total: 0, nr: 0 },
    size: { XS: 10, S: 5, M: 4, L: 9, XL: 0, XXL: 4 },
    id: 'mtd8'
  }, mtd9: {
    name: 'Tricou simplu',
    price: 99.99,
    discount: 0.1,
    photo: turqoiseTeeFront,
    sliderPhoto: [turqoiseTeeBack],
    sex: 'man',
    type: 'barbati top tricouri',
    colors: ['#00ffd8', '#eee'],
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    star: { total: 0, nr: 0 },
    size: { XS: 20, S: 0, M: 4, L: 9, XL: 1, XXL: 4 },
    id: 'mtd9'
  }, mtd10: {
    name: 'Tricou simplu',
    price: 29.99,
    discount: 0.2,
    photo: whiteTeeFront,
    sliderPhoto: [whiteTeeBack],
    sex: 'man',
    type: 'barbati top tricouri',
    colors: ['#eee', '#1c1919'],
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    star: { total: 0, nr: 0 },
    size: { XS: 20, S: 0, M: 4, L: 9, XL: 1, XXL: 4 },
    id: 'mtd10'
  }, mtd11: {
    name: 'Tricou simplu',
    price: 29.99,
    discount: 0.4,
    photo: yellowTeeFront,
    sliderPhoto: [yellowTeeBack],
    sex: 'man',
    type: 'barbati top tricouri',
    colors: ['#fff600', '#eee'],
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    star: { total: 0, nr: 0 },
    size: { XS: 4, S: 5, M: 0, L: 2, XL: 1, XXL: 9 },
    id: 'mtd11'
  }, mhp1: {
    name: 'Hanorac cu pattern',
    price: 129.99,
    discount: 0,
    photo: blueHooFrontPatern,
    sliderPhoto: [blueHooBackPatern, blueHooLeftPatern, blueHooRightPatern],
    sex: 'man',
    type: 'barbati top bluze',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#0091e5', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 4, S: 5, M: 0, L: 0, XL: 7, XXL: 3 },
    id: 'mhp1',
  }, mhp2: {
    name: 'Hanorac cu pattern',
    price: 129.99,
    discount: 0,
    photo: redHooFrontPatern,
    sliderPhoto: [redHooBackPatern, redHooLeftPatern, redHooRightPatern],
    sex: 'man',
    type: 'barbati top bluze',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#ea0000', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 4, S: 5, M: 3, L: 1, XL: 7, XXL: 3 },
    id: 'mhp2',
  }, mhp3: {
    name: 'Hanorac cu pattern',
    price: 129.99,
    discount: 0,
    photo: yellowHooFrontPatern,
    sliderPhoto: [yellowHooBackPatern, yellowHooLeftPatern, yellowHooRightPatern],
    sex: 'man',
    type: 'barbati top bluze',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#fff600', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 4, S: 5, M: 0, L: 0, XL: 7, XXL: 3 },
    id: 'mhp3',
  }, mhp4: {
    name: 'Hanorac cu pattern',
    price: 129.99,
    discount: 0,
    photo: whiteHooFrontPatern,
    sliderPhoto: [whiteHooBackPatern, whiteHooLeftPatern, whiteHooRightPatern],
    sex: 'man',
    type: 'barbati top bluze',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#eee', '#ea0000'],
    star: { total: 0, nr: 0 },
    size: { XS: 0, S: 2, M: 5, L: 6, XL: 7, XXL: 3 },
    id: 'mhp4',
  }, mhp5: {
    name: 'Hanorac cu pattern',
    price: 129.99,
    discount: 0,
    photo: greenHooFrontPatern,
    sliderPhoto: [greenHooBackPatern, greenHooLeftPatern, greenHooRightPatern],
    sex: 'man',
    type: 'barbati top bluze',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#72ff00', '#0091e5'],
    star: { total: 0, nr: 0 },
    size: { XS: 4, S: 0, M: 2, L: 6, XL: 0, XXL: 3 },
    id: 'mhp5',
  }, mhp6: {
    name: 'Hanorac custom',
    price: 129.99,
    discount: 0,
    photo: sprayHooFrontCustom,
    sliderPhoto: [sprayHooBackCustom, sprayHooLeftCustom, sprayHooRightCustom],
    sex: 'man',
    type: 'barbati top bluze',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#1c1919', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 0, L: 3, XL: 4, XXL: 3 },
    id: 'mhp6',
  }, mhp7: {
    name: 'Hanorac custom',
    price: 129.99,
    discount: 0,
    photo: bascketHooFrontCustom,
    sliderPhoto: [bascketHooBackCustom, bascketHooLeftCustom, bascketHooRightCustom],
    sex: 'man',
    type: 'barbati top bluze',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#1c1919', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 0, S: 6, M: 3, L: 2, XL: 5, XXL: 4 },
    id: 'mhp7',
  }, mhp8: {
    name: 'Hanorac custom',
    price: 129.99,
    discount: 0,
    photo: shapeHooFrontCustom,
    sliderPhoto: [shapeHooBackCustom, shapeHooLeftCustom, shapeHooRightCustom],
    sex: 'man',
    type: 'barbati top bluze',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#1c1919', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 4, S: 5, M: 2, L: 6, XL: 7, XXL: 3 },
    id: 'mhp8',
  }, mhp9: {
    name: 'Hanorac Snake',
    price: 129.99,
    discount: 0.2,
    photo: snakeHooFrontCustom,
    sliderPhoto: [snakeHooBackCustom, snakeHooLeftCustom, snakeHooRightCustom],
    sex: 'man',
    type: 'barbati top bluze',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#1c1919', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 2, S: 5, M: 4, L: 0, XL: 3, XXL: 1 },
    id: 'mhp9',
  }, mhd1: {
    name: 'Hanorac simplu',
    price: 99.99,
    discount: 0,
    photo: blueHooFront,
    sliderPhoto: [blueHooBack, blueHooLeft, blueHooRight],
    sex: 'man',
    type: 'barbati top bluze',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#0091e5', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 4, S: 5, M: 5, L: 6, XL: 7, XXL: 6 },
    id: 'mhd1',
  }, mhd2: {
    name: 'Hanorac simplu',
    price: 79.99,
    discount: 0,
    photo: cyanHooFront,
    sliderPhoto: [cyanHooBack, cyanHooLeft, cyanHooRight],
    sex: 'man',
    type: 'barbati top bluze',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#00d2ff', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 4, S: 7, M: 9, L: 1, XL: 7, XXL: 0 },
    id: 'mhd2',
  }, mhd3: {
    name: 'Hanorac simplu',
    price: 109.99,
    discount: 0,
    photo: greenHooFront,
    sliderPhoto: [greenHooBack, greenHooLeft, greenHooRight],
    sex: 'man',
    type: 'barbati top bluze',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#72ff00', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 4, S: 5, M: 6, L: 0, XL: 7, XXL: 0 },
    id: 'mhd3',
  }, mhd4: {
    name: 'Hanorac simplu',
    price: 139.99,
    discount: 0.3,
    photo: orangeHooFront,
    sliderPhoto: [orangeHooBack, orangeHooLeft, orangeHooRight],
    sex: 'man',
    type: 'barbati top bluze',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#fd6500', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 6, S: 6, M: 14, L: 15, XL: 21, XXL: 23 },
    id: 'mhd4',
  }, mhd5: {
    name: 'Hanorac simplu',
    price: 99.99,
    discount: 0.2,
    photo: pinkHooFront,
    sliderPhoto: [pinkHooBack, pinkHooLeft, pinkHooRight],
    sex: 'man',
    type: 'barbati top bluze',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#ff00f0', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 5, S: 5, M: 3, L: 0, XL: 2, XXL: 6 },
    id: 'mhd5',
  }, mhd6: {
    name: 'Hanorac simplu',
    price: 79.99,
    discount: 0,
    photo: purpleHooFront,
    sliderPhoto: [purpleHooBack, purpleHooLeft, purpleHooRight],
    sex: 'man',
    type: 'barbati top bluze',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#a200ff', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 0, S: 0, M: 4, L: 2, XL: 7, XXL: 3 },
    id: 'mhd6',
  }, mhd7: {
    name: 'Hanorac simplu',
    price: 94.99,
    discount: 0,
    photo: redHooFront,
    sliderPhoto: [redHooBack, redHooLeft, redHooRight],
    sex: 'man',
    type: 'barbati top bluze',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#ea0000', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 4, S: 6, M: 3, L: 7, XL: 7, XXL: 3 },
    id: 'mhd7',
  }, mhd8: {
    name: 'Hanorac simplu',
    price: 59.99,
    discount: 0,
    photo: turqoiseHooFront,
    sliderPhoto: [turqoiseHooBack, turqoiseHooLeft, turqoiseHooRight],
    sex: 'man',
    type: 'barbati top bluze',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#00ffd8', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 6, S: 3, M: 0, L: 9, XL: 11, XXL: 21 },
    id: 'mhd8',
  }, mhd9: {
    name: 'Hanorac simplu',
    price: 69.99,
    discount: 0,
    photo: blackHooFront,
    sliderPhoto: [blackHooBack, blackHooLeft, blackHooRight],
    sex: 'man',
    type: 'barbati top bluze',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#1c1919', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 6, S: 2, M: 4, L: 3, XL: 0, XXL: 0 },
    id: 'mhd9',
  }, mhd10: {
    name: 'Hanorac simplu',
    price: 119.99,
    discount: 0.2,
    photo: yellowHooFront,
    sliderPhoto: [yellowHooBack, yellowHooLeft, yellowHooRight],
    sex: 'man',
    type: 'barbati top bluze',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#ffd600', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 0, S: 7, M: 6, L: 5, XL: 3, XXL: 0 },
    id: 'mhd10',
  }, mpb1: {
    name: 'Pantaloni simpli',
    price: 119.99,
    discount: 0.2,
    photo: manblackPanBrownFront,
    sliderPhoto: [manLayoutPanBrownBack],
    sex: 'man',
    type: 'barbati bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#1c1919', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 0, S: 7, M: 6, L: 5, XL: 3, XXL: 0 },
    id: 'mpb1',
  }, mpb2: {
    name: 'Pantaloni simpli',
    price: 119.99,
    discount: 0.2,
    photo: manbluePanBrownFront,
    sliderPhoto: [manLayoutPanBrownBack],
    sex: 'man',
    type: 'barbati bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#0091e5', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 0, S: 7, M: 6, L: 5, XL: 3, XXL: 0 },
    id: 'mpb2',
  }, mpb3: {
    name: 'Pantaloni simpli',
    price: 119.99,
    discount: 0.2,
    photo: mancyanPanBrownFront,
    sliderPhoto: [manLayoutPanBrownBack],
    sex: 'man',
    type: 'barbati bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#00d2ff', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 0, S: 7, M: 6, L: 5, XL: 3, XXL: 0 },
    id: 'mpb3',
  }, mpb4: {
    name: 'Pantaloni simpli',
    price: 119.99,
    discount: 0.2,
    photo: mangreenPanBrownFront,
    sliderPhoto: [manLayoutPanBrownBack],
    sex: 'man',
    type: 'barbati bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#72ff00', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 0, S: 7, M: 6, L: 5, XL: 3, XXL: 0 },
    id: 'mpb4',
  }, mpb5: {
    name: 'Pantaloni simpli',
    price: 119.99,
    discount: 0.2,
    photo: manorangePanBrownFront,
    sliderPhoto: [manLayoutPanBrownBack],
    sex: 'man',
    type: 'barbati bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#fd6500', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 0, S: 7, M: 6, L: 5, XL: 3, XXL: 0 },
    id: 'mpb5',
  }, mpb6: {
    name: 'Pantaloni simpli',
    price: 119.99,
    discount: 0.2,
    photo: manpinkPanBrownFront,
    sliderPhoto: [manLayoutPanBrownBack],
    sex: 'man',
    type: 'barbati bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#ff00f0', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 0, S: 7, M: 6, L: 5, XL: 3, XXL: 0 },
    id: 'mpb6',
  }, mpb7: {
    name: 'Pantaloni simpli',
    price: 119.99,
    discount: 0.2,
    photo: manpurplePanBrownFront,
    sliderPhoto: [manLayoutPanBrownBack],
    sex: 'man',
    type: 'barbati bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#a200ff', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 0, S: 7, M: 6, L: 5, XL: 3, XXL: 0 },
    id: 'mpb7',
  }, mpb8: {
    name: 'Pantaloni simpli',
    price: 119.99,
    discount: 0.2,
    photo: manredPanBrownFront,
    sliderPhoto: [manLayoutPanBrownBack],
    sex: 'man',
    type: 'barbati bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#ea0000', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 0, S: 7, M: 6, L: 5, XL: 3, XXL: 0 },
    id: 'mpb8',
  }, mpb9: {
    name: 'Pantaloni simpli',
    price: 119.99,
    discount: 0.2,
    photo: manturqoisePanBrownFront,
    sliderPhoto: [manLayoutPanBrownBack],
    sex: 'man',
    type: 'barbati bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#00ffd8', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 0, S: 7, M: 6, L: 5, XL: 3, XXL: 0 },
    id: 'mpb9',
  }, mpb10: {
    name: 'Pantaloni simpli',
    price: 119.99,
    discount: 0.2,
    photo: manwhitePanBrownFront,
    sliderPhoto: [manLayoutPanBrownBack],
    sex: 'man',
    type: 'barbati bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#eee', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 0, S: 7, M: 6, L: 5, XL: 3, XXL: 0 },
    id: 'mpb10',
  }, mpb11: {
    name: 'Pantaloni simpli',
    price: 119.99,
    discount: 0.2,
    photo: manyellowPanBrownFront,
    sliderPhoto: [manLayoutPanBrownBack],
    sex: 'man',
    type: 'barbati bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#fff600', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 0, S: 7, M: 6, L: 5, XL: 3, XXL: 0 },
    id: 'mpb11',
  }, mpg1: {
    name: 'Pantaloni simpli',
    price: 119.99,
    discount: 0,
    photo: manblackPanGreyFront,
    sliderPhoto: [manLayoutPanGreyBack],
    sex: 'man',
    type: 'barbati bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#1c1919', '#bdbeb4'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'mpg1',
  }, mpg2: {
    name: 'Pantaloni simpli',
    price: 119.99,
    discount: 0,
    photo: manbluePanGreyFront,
    sliderPhoto: [manLayoutPanGreyBack],
    sex: 'man',
    type: 'barbati bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#0091e5', '#bdbeb4'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'mpg2',
  }, mpg3: {
    name: 'Pantaloni simpli',
    price: 119.99,
    discount: 0,
    photo: mancyanPanGreyFront,
    sliderPhoto: [manLayoutPanGreyBack],
    sex: 'man',
    type: 'barbati bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#00d2ff', '#bdbeb4'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'mpg3',
  }, mpg4: {
    name: 'Pantaloni simpli',
    price: 119.99,
    discount: 0,
    photo: mangreenPanGreyFront,
    sliderPhoto: [manLayoutPanGreyBack],
    sex: 'man',
    type: 'barbati bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#72ff00', '#bdbeb4'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'mpg4',
  }, mpg5: {
    name: 'Pantaloni simpli',
    price: 119.99,
    discount: 0,
    photo: manorangePanGreyFront,
    sliderPhoto: [manLayoutPanGreyBack],
    sex: 'man',
    type: 'barbati bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#fd6500', '#bdbeb4'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'mpg5',
  }, mpg6: {
    name: 'Pantaloni simpli',
    price: 119.99,
    discount: 0,
    photo: manpinkPanGreyFront,
    sliderPhoto: [manLayoutPanGreyBack],
    sex: 'man',
    type: 'barbati bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#ff00f0', '#bdbeb4'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'mpg6',
  }, mpg7: {
    name: 'Pantaloni simpli',
    price: 119.99,
    discount: 0,
    photo: manpurplePanGreyFront,
    sliderPhoto: [manLayoutPanGreyBack],
    sex: 'man',
    type: 'barbati bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#a200ff', '#bdbeb4'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'mpg7',
  }, mpg8: {
    name: 'Pantaloni simpli',
    price: 119.99,
    discount: 0,
    photo: manredPanGreyFront,
    sliderPhoto: [manLayoutPanGreyBack],
    sex: 'man',
    type: 'barbati bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#ea0000', '#bdbeb4'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'mpg8',
  }, mpg9: {
    name: 'Pantaloni simpli',
    price: 119.99,
    discount: 0,
    photo: manturqoisePanGreyFront,
    sliderPhoto: [manLayoutPanGreyBack],
    sex: 'man',
    type: 'barbati bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#00ffd8', '#bdbeb4'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'mpg9',
  }, mpg10: {
    name: 'Pantaloni simpli',
    price: 119.99,
    discount: 0,
    photo: manwhitePanGreyFront,
    sliderPhoto: [manLayoutPanGreyBack],
    sex: 'man',
    type: 'barbati bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#eee', '#bdbeb4'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'mpg10',
  }, mpg11: {
    name: 'Pantaloni simpli',
    price: 119.99,
    discount: 0,
    photo: manyellowPanGreyFront,
    sliderPhoto: [manLayoutPanGreyBack],
    sex: 'man',
    type: 'barbati bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#fff600', '#bdbeb4'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'mpg11',
  }, mpr1: {
    name: 'Pantaloni simpli',
    price: 119.99,
    discount: 0,
    photo: manblackPanRedFront,
    sliderPhoto: [manLayoutPanRedBack],
    sex: 'man',
    type: 'barbati bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#1c1919', '#ea0000'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'mpr1',
  }, mpr2: {
    name: 'Pantaloni simpli',
    price: 119.99,
    discount: 0,
    photo: manbluePanRedFront,
    sliderPhoto: [manLayoutPanRedBack],
    sex: 'man',
    type: 'barbati bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#0091e5', '#ea0000'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'mpr2',
  }, mpr3: {
    name: 'Pantaloni simpli',
    price: 119.99,
    discount: 0,
    photo: mancyanPanRedFront,
    sliderPhoto: [manLayoutPanRedBack],
    sex: 'man',
    type: 'barbati bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#00d2ff', '#ea0000'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'mpr3',
  }, mpr4: {
    name: 'Pantaloni simpli',
    price: 119.99,
    discount: 0,
    photo: mangreenPanRedFront,
    sliderPhoto: [manLayoutPanRedBack],
    sex: 'man',
    type: 'barbati bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#72ff00', '#ea0000'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'mpr4',
  }, mpr5: {
    name: 'Pantaloni simpli',
    price: 119.99,
    discount: 0,
    photo: manorangePanRedFront,
    sliderPhoto: [manLayoutPanRedBack],
    sex: 'man',
    type: 'barbati bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#fd6500', '#ea0000'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'mpr5',
  }, mpr6: {
    name: 'Pantaloni simpli',
    price: 119.99,
    discount: 0,
    photo: manpinkPanRedFront,
    sliderPhoto: [manLayoutPanRedBack],
    sex: 'man',
    type: 'barbati bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#ff00f0', '#ea0000'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'mpr6',
  }, mpr7: {
    name: 'Pantaloni simpli',
    price: 119.99,
    discount: 0,
    photo: manpurplePanRedFront,
    sliderPhoto: [manLayoutPanRedBack],
    sex: 'man',
    type: 'barbati bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#a200ff', '#ea0000'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'mpr7',
  }, mpr8: {
    name: 'Pantaloni simpli',
    price: 119.99,
    discount: 0,
    photo: manredPanRedFront,
    sliderPhoto: [manLayoutPanRedBack],
    sex: 'man',
    type: 'barbati bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#ea0000', '#ea0000'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'mpr8',
  }, mpr9: {
    name: 'Pantaloni simpli',
    price: 119.99,
    discount: 0,
    photo: manturqoisePanRedFront,
    sliderPhoto: [manLayoutPanRedBack],
    sex: 'man',
    type: 'barbati bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#00ffd8', '#ea0000'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'mpr9',
  }, mpr10: {
    name: 'Pantaloni simpli',
    price: 119.99,
    discount: 0,
    photo: manwhitePanRedFront,
    sliderPhoto: [manLayoutPanRedBack],
    sex: 'man',
    type: 'barbati bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#eee', '#ea0000'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'mpr10',
  }, mpr11: {
    name: 'Pantaloni simpli',
    price: 119.99,
    discount: 0,
    photo: manyellowPanRedFront,
    sliderPhoto: [manLayoutPanRedBack],
    sex: 'man',
    type: 'barbati bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#fff600', '#ea0000'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'mpr11',
  }, mpo1: {
    name: 'Pantaloni simpli',
    price: 119.99,
    discount: 0,
    photo: manblackPanOrangeFront,
    sliderPhoto: [manLayoutPanOrangeBack],
    sex: 'man',
    type: 'barbati bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#1c1919', '#fd6500'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'mpo1',
  }, mpo2: {
    name: 'Pantaloni simpli',
    price: 119.99,
    discount: 0,
    photo: manbluePanOrangeFront,
    sliderPhoto: [manLayoutPanOrangeBack],
    sex: 'man',
    type: 'barbati bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#0091e5', '#fd6500'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'mpo2',
  }, mpo3: {
    name: 'Pantaloni simpli',
    price: 119.99,
    discount: 0,
    photo: mancyanPanOrangeFront,
    sliderPhoto: [manLayoutPanOrangeBack],
    sex: 'man',
    type: 'barbati bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#00d2ff', '#fd6500'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'mpo3',
  }, mpo4: {
    name: 'Pantaloni simpli',
    price: 119.99,
    discount: 0,
    photo: mangreenPanOrangeFront,
    sliderPhoto: [manLayoutPanOrangeBack],
    sex: 'man',
    type: 'barbati bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#72ff00', '#fd6500'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'mpo4',
  }, mpo5: {
    name: 'Pantaloni simpli',
    price: 119.99,
    discount: 0,
    photo: manorangePanOrangeFront,
    sliderPhoto: [manLayoutPanOrangeBack],
    sex: 'man',
    type: 'barbati bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#fd6500', '#fd6500'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'mpo5',
  }, mpo6: {
    name: 'Pantaloni simpli',
    price: 119.99,
    discount: 0,
    photo: manpinkPanOrangeFront,
    sliderPhoto: [manLayoutPanOrangeBack],
    sex: 'man',
    type: 'barbati bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#ff00f0', '#fd6500'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'mpo6',
  }, mpo7: {
    name: 'Pantaloni simpli',
    price: 119.99,
    discount: 0,
    photo: manpurplePanOrangeFront,
    sliderPhoto: [manLayoutPanOrangeBack],
    sex: 'man',
    type: 'barbati bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#a200ff', '#fd6500'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'mpo7',
  }, mpo8: {
    name: 'Pantaloni simpli',
    price: 119.99,
    discount: 0,
    photo: manredPanOrangeFront,
    sliderPhoto: [manLayoutPanOrangeBack],
    sex: 'man',
    type: 'barbati bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#ea0000', '#fd6500'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'mpo8',
  }, mpo9: {
    name: 'Pantaloni simpli',
    price: 119.99,
    discount: 0,
    photo: manturqoisePanOrangeFront,
    sliderPhoto: [manLayoutPanOrangeBack],
    sex: 'man',
    type: 'barbati bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#00ffd8', '#fd6500'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'mpo9',
  }, mpo10: {
    name: 'Pantaloni simpli',
    price: 119.99,
    discount: 0,
    photo: manwhitePanOrangeFront,
    sliderPhoto: [manLayoutPanOrangeBack],
    sex: 'man',
    type: 'barbati bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#eee', '#fd6500'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'mpo10',
  }, mpo11: {
    name: 'Pantaloni simpli',
    price: 119.99,
    discount: 0,
    photo: manyellowPanOrangeFront,
    sliderPhoto: [manLayoutPanOrangeBack],
    sex: 'man',
    type: 'barbati bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#fff600', '#fd6500'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'mpo11',
  }, mpsb1: {
    name: 'Pantaloni Snake',
    price: 119.99,
    discount: 0.2,
    photo: manSnakeblackPanBrownFront,
    sliderPhoto: [manLayoutPanBrownBack],
    sex: 'man',
    type: 'barbati bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#1c1919', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 0, S: 7, M: 6, L: 5, XL: 3, XXL: 0 },
    id: 'mpsb1',
  }, mpsb2: {
    name: 'Pantaloni Snake',
    price: 119.99,
    discount: 0.2,
    photo: manSnakebluePanBrownFront,
    sliderPhoto: [manLayoutPanBrownBack],
    sex: 'man',
    type: 'barbati bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#0091e5', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 0, S: 7, M: 6, L: 5, XL: 3, XXL: 0 },
    id: 'mpsb2',
  }, mpsb3: {
    name: 'Pantaloni Snake',
    price: 119.99,
    discount: 0.2,
    photo: manSnakecyanPanBrownFront,
    sliderPhoto: [manLayoutPanBrownBack],
    sex: 'man',
    type: 'barbati bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#00d2ff', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 0, S: 7, M: 6, L: 5, XL: 3, XXL: 0 },
    id: 'mpsb3',
  }, mpsb4: {
    name: 'Pantaloni Snake',
    price: 119.99,
    discount: 0.2,
    photo: manSnakegreenPanBrownFront,
    sliderPhoto: [manLayoutPanBrownBack],
    sex: 'man',
    type: 'barbati bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#72ff00', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 0, S: 7, M: 6, L: 5, XL: 3, XXL: 0 },
    id: 'mpsb4',
  }, mpsb5: {
    name: 'Pantaloni Snake',
    price: 119.99,
    discount: 0.2,
    photo: manSnakeorangePanBrownFront,
    sliderPhoto: [manLayoutPanBrownBack],
    sex: 'man',
    type: 'barbati bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#fd6500', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 0, S: 7, M: 6, L: 5, XL: 3, XXL: 0 },
    id: 'mpsb5',
  }, mpsb6: {
    name: 'Pantaloni Snake',
    price: 119.99,
    discount: 0.2,
    photo: manSnakepinkPanBrownFront,
    sliderPhoto: [manLayoutPanBrownBack],
    sex: 'man',
    type: 'barbati bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#ff00f0', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 0, S: 7, M: 6, L: 5, XL: 3, XXL: 0 },
    id: 'mpsb6',
  }, mpsb7: {
    name: 'Pantaloni Snake',
    price: 119.99,
    discount: 0.2,
    photo: manSnakepurplePanBrownFront,
    sliderPhoto: [manLayoutPanBrownBack],
    sex: 'man',
    type: 'barbati bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#a200ff', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 0, S: 7, M: 6, L: 5, XL: 3, XXL: 0 },
    id: 'mpsb7',
  }, mpsb8: {
    name: 'Pantaloni Snake',
    price: 119.99,
    discount: 0.2,
    photo: manSnakeredPanBrownFront,
    sliderPhoto: [manLayoutPanBrownBack],
    sex: 'man',
    type: 'barbati bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#ea0000', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 0, S: 7, M: 6, L: 5, XL: 3, XXL: 0 },
    id: 'mpsb8',
  }, mpsb9: {
    name: 'Pantaloni Snake',
    price: 119.99,
    discount: 0.2,
    photo: manSnaketurqoisePanBrownFront,
    sliderPhoto: [manLayoutPanBrownBack],
    sex: 'man',
    type: 'barbati bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#00ffd8', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 0, S: 7, M: 6, L: 5, XL: 3, XXL: 0 },
    id: 'mpsb9',
  }, mpsb10: {
    name: 'Pantaloni Snake',
    price: 119.99,
    discount: 0.2,
    photo: manSnakewhitePanBrownFront,
    sliderPhoto: [manLayoutPanBrownBack],
    sex: 'man',
    type: 'barbati bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#eee', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 0, S: 7, M: 6, L: 5, XL: 3, XXL: 0 },
    id: 'mpsb10',
  }, mpsb11: {
    name: 'Pantaloni Snake',
    price: 119.99,
    discount: 0.2,
    photo: manSnakeyellowPanBrownFront,
    sliderPhoto: [manLayoutPanBrownBack],
    sex: 'man',
    type: 'barbati bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#fff600', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 0, S: 7, M: 6, L: 5, XL: 3, XXL: 0 },
    id: 'mpsb11',
  }, mpsg1: {
    name: 'Pantaloni Snake',
    price: 119.99,
    discount: 0,
    photo: manSnakeblackPanGreyFront,
    sliderPhoto: [manLayoutPanGreyBack],
    sex: 'man',
    type: 'barbati bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#1c1919', '#bdbeb4'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'mpsg1',
  }, mpsg2: {
    name: 'Pantaloni Snake',
    price: 119.99,
    discount: 0,
    photo: manSnakebluePanGreyFront,
    sliderPhoto: [manLayoutPanGreyBack],
    sex: 'man',
    type: 'barbati bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#0091e5', '#bdbeb4'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'mpsg2',
  }, mpsg3: {
    name: 'Pantaloni Snake',
    price: 119.99,
    discount: 0,
    photo: manSnakecyanPanGreyFront,
    sliderPhoto: [manLayoutPanGreyBack],
    sex: 'man',
    type: 'barbati bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#00d2ff', '#bdbeb4'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'mpsg3',
  }, mpsg4: {
    name: 'Pantaloni Snake',
    price: 119.99,
    discount: 0,
    photo: manSnakegreenPanGreyFront,
    sliderPhoto: [manLayoutPanGreyBack],
    sex: 'man',
    type: 'barbati bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#72ff00', '#bdbeb4'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'mpsg4',
  }, mpsg5: {
    name: 'Pantaloni Snake',
    price: 119.99,
    discount: 0,
    photo: manSnakeorangePanGreyFront,
    sliderPhoto: [manLayoutPanGreyBack],
    sex: 'man',
    type: 'barbati bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#fd6500', '#bdbeb4'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'mpsg5',
  }, mpsg6: {
    name: 'Pantaloni Snake',
    price: 119.99,
    discount: 0,
    photo: manSnakepinkPanGreyFront,
    sliderPhoto: [manLayoutPanGreyBack],
    sex: 'man',
    type: 'barbati bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#ff00f0', '#bdbeb4'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'mpsg6',
  }, mpsg7: {
    name: 'Pantaloni Snake',
    price: 119.99,
    discount: 0,
    photo: manSnakepurplePanGreyFront,
    sliderPhoto: [manLayoutPanGreyBack],
    sex: 'man',
    type: 'barbati bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#a200ff', '#bdbeb4'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'mpsg7',
  }, mpsg8: {
    name: 'Pantaloni Snake',
    price: 119.99,
    discount: 0,
    photo: manSnakeredPanGreyFront,
    sliderPhoto: [manLayoutPanGreyBack],
    sex: 'man',
    type: 'barbati bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#ea0000', '#bdbeb4'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'mpsg8',
  }, mpsg9: {
    name: 'Pantaloni Snake',
    price: 119.99,
    discount: 0,
    photo: manSnaketurqoisePanGreyFront,
    sliderPhoto: [manLayoutPanGreyBack],
    sex: 'man',
    type: 'barbati bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#00ffd8', '#bdbeb4'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'mpsg9',
  }, mpsg10: {
    name: 'Pantaloni Snake',
    price: 119.99,
    discount: 0,
    photo: manSnakewhitePanGreyFront,
    sliderPhoto: [manLayoutPanGreyBack],
    sex: 'man',
    type: 'barbati bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#eee', '#bdbeb4'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'mpsg10',
  }, mpsg11: {
    name: 'Pantaloni Snake',
    price: 119.99,
    discount: 0,
    photo: manSnakeyellowPanGreyFront,
    sliderPhoto: [manLayoutPanGreyBack],
    sex: 'man',
    type: 'barbati bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#fff600', '#bdbeb4'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'mpsg11',
  }, mpsr1: {
    name: 'Pantaloni Snake',
    price: 119.99,
    discount: 0,
    photo: manSnakeblackPanRedFront,
    sliderPhoto: [manLayoutPanRedBack],
    sex: 'man',
    type: 'barbati bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#1c1919', '#ea0000'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'mpsr1',
  }, mpsr2: {
    name: 'Pantaloni Snake',
    price: 119.99,
    discount: 0,
    photo: manSnakebluePanRedFront,
    sliderPhoto: [manLayoutPanRedBack],
    sex: 'man',
    type: 'barbati bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#0091e5', '#ea0000'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'mpsr2',
  }, mpsr3: {
    name: 'Pantaloni Snake',
    price: 119.99,
    discount: 0,
    photo: manSnakecyanPanRedFront,
    sliderPhoto: [manLayoutPanRedBack],
    sex: 'man',
    type: 'barbati bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#00d2ff', '#ea0000'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'mpsr3',
  }, mpsr4: {
    name: 'Pantaloni Snake',
    price: 119.99,
    discount: 0,
    photo: manSnakegreenPanRedFront,
    sliderPhoto: [manLayoutPanRedBack],
    sex: 'man',
    type: 'barbati bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#72ff00', '#ea0000'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'mpsr4',
  }, mpsr5: {
    name: 'Pantaloni Snake',
    price: 119.99,
    discount: 0,
    photo: manSnakeorangePanRedFront,
    sliderPhoto: [manLayoutPanRedBack],
    sex: 'man',
    type: 'barbati bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#fd6500', '#ea0000'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'mpsr5',
  }, mpsr6: {
    name: 'Pantaloni Snake',
    price: 119.99,
    discount: 0,
    photo: manSnakepinkPanRedFront,
    sliderPhoto: [manLayoutPanRedBack],
    sex: 'man',
    type: 'barbati bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#ff00f0', '#ea0000'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'mpsr6',
  }, mpsr7: {
    name: 'Pantaloni Snake',
    price: 119.99,
    discount: 0,
    photo: manSnakepurplePanRedFront,
    sliderPhoto: [manLayoutPanRedBack],
    sex: 'man',
    type: 'barbati bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#a200ff', '#ea0000'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'mpsr7',
  }, mpsr8: {
    name: 'Pantaloni Snake',
    price: 119.99,
    discount: 0,
    photo: manSnakeredPanRedFront,
    sliderPhoto: [manLayoutPanRedBack],
    sex: 'man',
    type: 'barbati bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#ea0000', '#ea0000'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'mpsr8',
  }, mpsr9: {
    name: 'Pantaloni Snake',
    price: 119.99,
    discount: 0,
    photo: manSnaketurqoisePanRedFront,
    sliderPhoto: [manLayoutPanRedBack],
    sex: 'man',
    type: 'barbati bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#00ffd8', '#ea0000'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'mpsr9',
  }, mpsr10: {
    name: 'Pantaloni Snake',
    price: 119.99,
    discount: 0,
    photo: manSnakewhitePanRedFront,
    sliderPhoto: [manLayoutPanRedBack],
    sex: 'man',
    type: 'barbati bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#eee', '#ea0000'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'mpsr10',
  }, mpsr11: {
    name: 'Pantaloni Snake',
    price: 119.99,
    discount: 0,
    photo: manSnakeyellowPanRedFront,
    sliderPhoto: [manLayoutPanRedBack],
    sex: 'man',
    type: 'barbati bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#fff600', '#ea0000'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'mpsr11',
  }, mpso1: {
    name: 'Pantaloni Snake',
    price: 119.99,
    discount: 0,
    photo: manSnakeblackPanOrangeFront,
    sliderPhoto: [manLayoutPanOrangeBack],
    sex: 'man',
    type: 'barbati bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#1c1919', '#fd6500'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'mpso1',
  }, mpso2: {
    name: 'Pantaloni Snake',
    price: 119.99,
    discount: 0,
    photo: manSnakebluePanOrangeFront,
    sliderPhoto: [manLayoutPanOrangeBack],
    sex: 'man',
    type: 'barbati bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#0091e5', '#fd6500'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'mpso2',
  }, mpso3: {
    name: 'Pantaloni Snake',
    price: 119.99,
    discount: 0,
    photo: manSnakecyanPanOrangeFront,
    sliderPhoto: [manLayoutPanOrangeBack],
    sex: 'man',
    type: 'barbati bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#00d2ff', '#fd6500'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'mpso3',
  }, mpso4: {
    name: 'Pantaloni Snake',
    price: 119.99,
    discount: 0,
    photo: manSnakegreenPanOrangeFront,
    sliderPhoto: [manLayoutPanOrangeBack],
    sex: 'man',
    type: 'barbati bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#72ff00', '#fd6500'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'mpso4',
  }, mpso5: {
    name: 'Pantaloni Snake',
    price: 119.99,
    discount: 0,
    photo: manSnakeorangePanOrangeFront,
    sliderPhoto: [manLayoutPanOrangeBack],
    sex: 'man',
    type: 'barbati bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#fd6500', '#fd6500'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'mpso5',
  }, mpso6: {
    name: 'Pantaloni Snake',
    price: 119.99,
    discount: 0,
    photo: manSnakepinkPanOrangeFront,
    sliderPhoto: [manLayoutPanOrangeBack],
    sex: 'man',
    type: 'barbati bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#ff00f0', '#fd6500'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'mpso6',
  }, mpso7: {
    name: 'Pantaloni Snake',
    price: 119.99,
    discount: 0,
    photo: manSnakepurplePanOrangeFront,
    sliderPhoto: [manLayoutPanOrangeBack],
    sex: 'man',
    type: 'barbati bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#a200ff', '#fd6500'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'mpso7',
  }, mpso8: {
    name: 'Pantaloni Snake',
    price: 119.99,
    discount: 0,
    photo: manSnakeredPanOrangeFront,
    sliderPhoto: [manLayoutPanOrangeBack],
    sex: 'man',
    type: 'barbati bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#ea0000', '#fd6500'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'mpso8',
  }, mpso9: {
    name: 'Pantaloni Snake',
    price: 119.99,
    discount: 0,
    photo: manSnaketurqoisePanOrangeFront,
    sliderPhoto: [manLayoutPanOrangeBack],
    sex: 'man',
    type: 'barbati bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#00ffd8', '#fd6500'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'mpso9',
  }, mpso10: {
    name: 'Pantaloni Snake',
    price: 119.99,
    discount: 0,
    photo: manSnakewhitePanOrangeFront,
    sliderPhoto: [manLayoutPanOrangeBack],
    sex: 'man',
    type: 'barbati bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#eee', '#fd6500'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'mpso10',
  }, mpso11: {
    name: 'Pantaloni Snake',
    price: 119.99,
    discount: 0,
    photo: manSnakeyellowPanOrangeFront,
    sliderPhoto: [manLayoutPanOrangeBack],
    sex: 'man',
    type: 'barbati bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#fff600', '#fd6500'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'mpso11',
  }, wdt1: {
    name: 'Tricou simplu',
    price: 119.99,
    discount: 0,
    photo: womanblackTeeFront,
    sliderPhoto: [womanLayoutTeeBack, womanLayoutTeeLeft, womanLayoutTeeRight],
    sex: 'woman',
    type: 'femei top tricouri',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#1c1919', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'wdt1',
  }, wdt2: {
    name: 'Tricou simplu',
    price: 119.99,
    discount: 0,
    photo: womanblueTeeFront,
    sliderPhoto: [womanLayoutTeeBack, womanLayoutTeeLeft, womanLayoutTeeRight],
    sex: 'woman',
    type: 'femei top tricouri',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#0091e5', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'wdt2',
  }, wdt3: {
    name: 'Tricou simplu',
    price: 119.99,
    discount: 0,
    photo: womancyanTeeFront,
    sliderPhoto: [womanLayoutTeeBack, womanLayoutTeeLeft, womanLayoutTeeRight],
    sex: 'woman',
    type: 'femei top tricouri',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#00d2ff', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'wdt3',
  }, wdt4: {
    name: 'Tricou simplu',
    price: 119.99,
    discount: 0,
    photo: womangreenTeeFront,
    sliderPhoto: [womanLayoutTeeBack, womanLayoutTeeLeft, womanLayoutTeeRight],
    sex: 'woman',
    type: 'femei top tricouri',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#72ff00', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'wdt4',
  }, wdt5: {
    name: 'Tricou simplu',
    price: 119.99,
    discount: 0,
    photo: womanorangeTeeFront,
    sliderPhoto: [womanLayoutTeeBack, womanLayoutTeeLeft, womanLayoutTeeRight],
    sex: 'woman',
    type: 'femei top tricouri',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#fd6500', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'wdt5',
  }, wdt6: {
    name: 'Tricou simplu',
    price: 119.99,
    discount: 0,
    photo: womanpinkTeeFront,
    sliderPhoto: [womanLayoutTeeBack, womanLayoutTeeLeft, womanLayoutTeeRight],
    sex: 'woman',
    type: 'femei top tricouri',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#ff00f0', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'wdt6',
  }, wdt7: {
    name: 'Tricou simplu',
    price: 119.99,
    discount: 0,
    photo: womanpurpleTeeFront,
    sliderPhoto: [womanLayoutTeeBack, womanLayoutTeeLeft, womanLayoutTeeRight],
    sex: 'woman',
    type: 'femei top tricouri',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#a200ff', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'wdt7',
  }, wdt8: {
    name: 'Tricou simplu',
    price: 119.99,
    discount: 0,
    photo: womanredTeeFront,
    sliderPhoto: [womanLayoutTeeBack, womanLayoutTeeLeft, womanLayoutTeeRight],
    sex: 'woman',
    type: 'femei top tricouri',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#ea0000', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'wdt8',
  }, wdt9: {
    name: 'Tricou simplu',
    price: 119.99,
    discount: 0,
    photo: womanturqoiseTeeFront,
    sliderPhoto: [womanLayoutTeeBack, womanLayoutTeeLeft, womanLayoutTeeRight],
    sex: 'woman',
    type: 'femei top tricouri',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#00ffd8', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'wdt9',
  }, wdt10: {
    name: 'Tricou simplu',
    price: 119.99,
    discount: 0,
    photo: womanyellowTeeFront,
    sliderPhoto: [womanLayoutTeeBack, womanLayoutTeeLeft, womanLayoutTeeRight],
    sex: 'woman',
    type: 'femei top tricouri',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#fff600', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'wdt10',
  }, mds1: {
    name: 'Pantaloni scurți simpli',
    price: 119.99,
    discount: 0,
    photo: manblackShoFront,
    sliderPhoto: [manLayoutShoBack, manLayoutShoLeft, manLayoutShoRight],
    sex: 'man',
    type: 'barbati bottom scurti',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#1c1919', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'mds1',
  }, mds2: {
    name: 'Pantaloni scurți simpli',
    price: 119.99,
    discount: 0,
    photo: manblueShoFront,
    sliderPhoto: [manLayoutShoBack, manLayoutShoLeft, manLayoutShoRight],
    sex: 'man',
    type: 'barbati bottom scurti',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#0091e5', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'mds2',
  }, mds3: {
    name: 'Pantaloni scurți simpli',
    price: 119.99,
    discount: 0,
    photo: mancyanShoFront,
    sliderPhoto: [manLayoutShoBack, manLayoutShoLeft, manLayoutShoRight],
    sex: 'man',
    type: 'barbati bottom scurti',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#00d2ff', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'mds3',
  }, mds4: {
    name: 'Pantaloni scurți simpli',
    price: 119.99,
    discount: 0,
    photo: mangreenShoFront,
    sliderPhoto: [manLayoutShoBack, manLayoutShoLeft, manLayoutShoRight],
    sex: 'man',
    type: 'barbati bottom scurti',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#72ff00', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'mds4',
  }, mds5: {
    name: 'Pantaloni scurți simpli',
    price: 119.99,
    discount: 0,
    photo: manorangeShoFront,
    sliderPhoto: [manLayoutShoBack, manLayoutShoLeft, manLayoutShoRight],
    sex: 'man',
    type: 'barbati bottom scurti',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#fd6500', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'mds5',
  }, mds6: {
    name: 'Pantaloni scurți simpli',
    price: 119.99,
    discount: 0,
    photo: manpinkShoFront,
    sliderPhoto: [manLayoutShoBack, manLayoutShoLeft, manLayoutShoRight],
    sex: 'man',
    type: 'barbati bottom scurti',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#ff00f0', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'mds6',
  }, mds7: {
    name: 'Pantaloni scurți simpli',
    price: 119.99,
    discount: 0,
    photo: manpurpleShoFront,
    sliderPhoto: [manLayoutShoBack, manLayoutShoLeft, manLayoutShoRight],
    sex: 'man',
    type: 'barbati bottom scurti',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#a200ff', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'mds7',
  }, mds8: {
    name: 'Pantaloni scurți simpli',
    price: 119.99,
    discount: 0,
    photo: manredShoFront,
    sliderPhoto: [manLayoutShoBack, manLayoutShoLeft, manLayoutShoRight],
    sex: 'man',
    type: 'barbati bottom scurti',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#ea0000', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'mds8',
  }, mds9: {
    name: 'Pantaloni scurți simpli',
    price: 119.99,
    discount: 0,
    photo: manturqoiseShoFront,
    sliderPhoto: [manLayoutShoBack, manLayoutShoLeft, manLayoutShoRight],
    sex: 'man',
    type: 'barbati bottom scurti',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#00ffd8', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'mds9',
  }, mds10: {
    name: 'Pantaloni scurți simpli',
    price: 119.99,
    discount: 0,
    photo: manyellowShoFront,
    sliderPhoto: [manLayoutShoBack, manLayoutShoLeft, manLayoutShoRight],
    sex: 'man',
    type: 'barbati bottom scurti',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#fff600', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'mds10',
  },
}
export const Product1 = {
  mpsr: {
    name: 'Pantaloni scurți pattern',
    price: 119.99,
    discount: 0,
    photo: manPatternShoRedFront,
    sliderPhoto: [manPatternShoRedBack, manPatternShoRedLeft, manPatternShoRedRight],
    sex: 'man',
    type: 'barbati bottom scurti',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#ea0000', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'mpsr',
  }, mpsw: {
    name: 'Pantaloni scurți pattern',
    price: 119.99,
    discount: 0,
    photo: manPatternShoWhiteFront,
    sliderPhoto: [manPatternShoWhiteBack, manPatternShoWhiteLeft, manPatternShoWhiteRight],
    sex: 'man',
    type: 'barbati bottom scurti',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#eee', '#ea0000'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'mpsw',
  }, wptr: {
    name: 'Tricou cu pattern',
    price: 119.99,
    discount: 0,
    photo: womanPatternTeeRedFront,
    sliderPhoto: [womanPatternTeeRedBack, womanPatternTeeRedLeft, womanPatternTeeRedRight],
    sex: 'woman',
    type: 'femei top tricouri',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#00ffd8', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'wptr',
  }, wpty: {
    name: 'Tricou cu pattern',
    price: 119.99,
    discount: 0,
    photo: womanPatternTeeYellowFront,
    sliderPhoto: [womanPatternTeeYellowBack, womanPatternTeeYellowLeft, womanPatternTeeYellowRight],
    sex: 'woman',
    type: 'femei top tricouri',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#fff600', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'wpty',
  }, wptw: {
    name: 'Tricou cu pattern',
    price: 119.99,
    discount: 0,
    photo: womanPatternTeeWhiteFront,
    sliderPhoto: [womanPatternTeeWhiteBack, womanPatternTeeWhiteLeft, womanPatternTeeWhiteRight],
    sex: 'woman',
    type: 'femei top tricouri',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#00ffd8', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'wptw',
  },
  mdsi1: {
    name: 'Bluză simplă',
    price: 119.99,
    discount: 0,
    photo: manDefaultblackShiFront,
    sliderPhoto: [manLayoutShiBack, manLayoutShiLeft, manLayoutShiRight],
    sex: 'man',
    type: 'barbati top bluze',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#1c1919', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'mdsi1',
  }, mdsi2: {
    name: 'Bluză simplă',
    price: 119.99,
    discount: 0,
    photo: manDefaultblueShiFront,
    sliderPhoto: [manLayoutShiBack, manLayoutShiLeft, manLayoutShiRight],
    sex: 'man',
    type: 'barbati top bluze',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#0091e5', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'mdsi2',
  }, mdsi3: {
    name: 'Bluză simplă',
    price: 119.99,
    discount: 0,
    photo: manDefaultcyanShiFront,
    sliderPhoto: [manLayoutShiBack, manLayoutShiLeft, manLayoutShiRight],
    sex: 'man',
    type: 'barbati top bluze',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#00d2ff', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'mdsi3',
  }, mdsi4: {
    name: 'Bluză simplă',
    price: 119.99,
    discount: 0,
    photo: manDefaultgreenShiFront,
    sliderPhoto: [manLayoutShiBack, manLayoutShiLeft, manLayoutShiRight],
    sex: 'man',
    type: 'barbati top bluze',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#72ff00', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'mdsi4',
  }, mdsi5: {
    name: 'Bluză simplă',
    price: 119.99,
    discount: 0,
    photo: manDefaultorangeShiFront,
    sliderPhoto: [manLayoutShiBack, manLayoutShiLeft, manLayoutShiRight],
    sex: 'man',
    type: 'barbati top bluze',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#fd6500', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'mdsi5',
  }, mdsi6: {
    name: 'Bluză simplă',
    price: 119.99,
    discount: 0,
    photo: manDefaultpinkShiFront,
    sliderPhoto: [manLayoutShiBack, manLayoutShiLeft, manLayoutShiRight],
    sex: 'man',
    type: 'barbati top bluze',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#ff00f0', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'mdsi6',
  }, mdsi7: {
    name: 'Bluză simplă',
    price: 119.99,
    discount: 0,
    photo: manDefaultpurpleShiFront,
    sliderPhoto: [manLayoutShiBack, manLayoutShiLeft, manLayoutShiRight],
    sex: 'man',
    type: 'barbati top bluze',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#a200ff', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'mdsi7',
  }, mdsi8: {
    name: 'Bluză simplă',
    price: 119.99,
    discount: 0,
    photo: manDefaultredShiFront,
    sliderPhoto: [manLayoutShiBack, manLayoutShiLeft, manLayoutShiRight],
    sex: 'man',
    type: 'barbati top bluze',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#ea0000', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'mdsi8',
  }, mdsi9: {
    name: 'Bluză simplă',
    price: 119.99,
    discount: 0,
    photo: manDefaultturqoiseShiFront,
    sliderPhoto: [manLayoutShiBack, manLayoutShiLeft, manLayoutShiRight],
    sex: 'man',
    type: 'barbati top bluze',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#00ffd8', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'mdsi9',
  }, mdsi10: {
    name: 'Bluză simplă',
    price: 119.99,
    discount: 0,
    photo: manDefaultyellowShiFront,
    sliderPhoto: [manLayoutShiBack, manLayoutShiLeft, manLayoutShiRight],
    sex: 'man',
    type: 'barbati top bluze',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#fff600', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'mdsi10',
  }, mssi1: {
    name: 'Bluză snake',
    price: 139.99,
    discount: 0.3,
    photo: manSnakeblackShiFront,
    sliderPhoto: [manLayoutShiBack, manLayoutShiLeft, manLayoutShiRight],
    sex: 'man',
    type: 'barbati top bluze',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#1c1919', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'mssi1',
  }, mssi2: {
    name: 'Bluză snake',
    price: 129.99,
    discount: 0.1,
    photo: manSnakeblueShiFront,
    sliderPhoto: [manLayoutShiBack, manLayoutShiLeft, manLayoutShiRight],
    sex: 'man',
    type: 'barbati top bluze',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#0091e5', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'mssi2',
  }, mssi3: {
    name: 'Bluză snake',
    price: 59.99,
    discount: 0,
    photo: manSnakecyanShiFront,
    sliderPhoto: [manLayoutShiBack, manLayoutShiLeft, manLayoutShiRight],
    sex: 'man',
    type: 'barbati top bluze',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#00d2ff', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'mssi3',
  }, mssi4: {
    name: 'Bluză snake',
    price: 94.99,
    discount: 0.2,
    photo: manSnakegreenShiFront,
    sliderPhoto: [manLayoutShiBack, manLayoutShiLeft, manLayoutShiRight],
    sex: 'man',
    type: 'barbati top bluze',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#72ff00', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'mssi4',
  }, mssi5: {
    name: 'Bluză snake',
    price: 99.99,
    discount: 0,
    photo: manSnakeorangeShiFront,
    sliderPhoto: [manLayoutShiBack, manLayoutShiLeft, manLayoutShiRight],
    sex: 'man',
    type: 'barbati top bluze',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#fd6500', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'mssi5',
  }, mssi6: {
    name: 'Bluză snake',
    price: 119.99,
    discount: 0,
    photo: manSnakepinkShiFront,
    sliderPhoto: [manLayoutShiBack, manLayoutShiLeft, manLayoutShiRight],
    sex: 'man',
    type: 'barbati top bluze',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#ff00f0', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'mssi6',
  }, mssi7: {
    name: 'Bluză snake',
    price: 69.99,
    discount: 0,
    photo: manSnakepurpleShiFront,
    sliderPhoto: [manLayoutShiBack, manLayoutShiLeft, manLayoutShiRight],
    sex: 'man',
    type: 'barbati top bluze',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#a200ff', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'mssi7',
  }, mssi8: {
    name: 'Bluză snake',
    price: 94.99,
    discount: 0,
    photo: manSnakeredShiFront,
    sliderPhoto: [manLayoutShiBack, manLayoutShiLeft, manLayoutShiRight],
    sex: 'man',
    type: 'barbati top bluze',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#ea0000', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'mssi8',
  }, mssi9: {
    name: 'Bluză snake',
    price: 99.99,
    discount: 0,
    photo: manSnaketurqoiseShiFront,
    sliderPhoto: [manLayoutShiBack, manLayoutShiLeft, manLayoutShiRight],
    sex: 'man',
    type: 'barbati top bluze',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#00ffd8', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'mssi9',
  }, mssi10: {
    name: 'Bluză snake',
    price: 109.99,
    discount: 0,
    photo: manSnakeyellowShiFront,
    sliderPhoto: [manLayoutShiBack, manLayoutShiLeft, manLayoutShiRight],
    sex: 'man',
    type: 'barbati top bluze',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#fff600', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'mssi10',
  }, wdta1: {
    name: 'Maiou simplu',
    price: 139.99,
    discount: 0.3,
    photo: womanblackTanFront,
    sliderPhoto: [womanLayoutTanBack, womanLayoutTanLeft, womanLayoutTanRight],
    sex: 'woman',
    type: 'femei top tricouri',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#1c1919', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'wdta1',
  }, wdta2: {
    name: 'Maiou simplu',
    price: 129.99,
    discount: 0.1,
    photo: womanblueTanFront,
    sliderPhoto: [womanLayoutTanBack, womanLayoutTanLeft, womanLayoutTanRight],
    sex: 'woman',
    type: 'femei top tricouri',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#0091e5', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'wdta2',
  }, wdta3: {
    name: 'Maiou simplu',
    price: 59.99,
    discount: 0,
    photo: womancyanTanFront,
    sliderPhoto: [womanLayoutTanBack, womanLayoutTanLeft, womanLayoutTanRight],
    sex: 'woman',
    type: 'femei top tricouri',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#00d2ff', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'wdta3',
  }, wdta4: {
    name: 'Maiou simplu',
    price: 94.99,
    discount: 0.2,
    photo: womangreenTanFront,
    sliderPhoto: [womanLayoutTanBack, womanLayoutTanLeft, womanLayoutTanRight],
    sex: 'woman',
    type: 'femei top tricouri',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#72ff00', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'wdta4',
  }, wdta5: {
    name: 'Maiou simplu',
    price: 99.99,
    discount: 0,
    photo: womanorangeTanFront,
    sliderPhoto: [womanLayoutTanBack, womanLayoutTanLeft, womanLayoutTanRight],
    sex: 'woman',
    type: 'femei top tricouri',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#fd6500', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'wdta5',
  }, wdta6: {
    name: 'Maiou simplu',
    price: 119.99,
    discount: 0,
    photo: womanpinkTanFront,
    sliderPhoto: [womanLayoutTanBack, womanLayoutTanLeft, womanLayoutTanRight],
    sex: 'woman',
    type: 'femei top tricouri',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#ff00f0', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'wdta6',
  }, wdta7: {
    name: 'Maiou simplu',
    price: 69.99,
    discount: 0,
    photo: womanpurpleTanFront,
    sliderPhoto: [womanLayoutTanBack, womanLayoutTanLeft, womanLayoutTanRight],
    sex: 'woman',
    type: 'femei top tricouri',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#a200ff', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'wdta7',
  }, wdta8: {
    name: 'Maiou simplu',
    price: 94.99,
    discount: 0,
    photo: womanredTanFront,
    sliderPhoto: [womanLayoutTanBack, womanLayoutTanLeft, womanLayoutTanRight],
    sex: 'woman',
    type: 'femei top tricouri',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#ea0000', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'wdta8',
  }, wdta9: {
    name: 'Maiou simplu',
    price: 99.99,
    discount: 0,
    photo: womanturqoiseTanFront,
    sliderPhoto: [womanLayoutTanBack, womanLayoutTanLeft, womanLayoutTanRight],
    sex: 'woman',
    type: 'femei top tricouri',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#00ffd8', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'wdta9',
  }, wdta10: {
    name: 'Maiou simplu',
    price: 109.99,
    discount: 0,
    photo: womanyellowTanFront,
    sliderPhoto: [womanLayoutTanBack, womanLayoutTanLeft, womanLayoutTanRight],
    sex: 'woman',
    type: 'femei top tricouri',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#fff600', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'wdta10',
  }, wst1: {
    name: 'Tricou snake',
    price: 139.99,
    discount: 0.3,
    photo: womanSnakeblackTeeFront,
    sliderPhoto: [womanLayoutTeeBack, womanSnakeblackTeeLeft, womanSnakeblackTeeRight],
    sex: 'woman',
    type: 'femei top tricouri',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#1c1919', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'wst1',
  }, wst2: {
    name: 'Tricou snake',
    price: 129.99,
    discount: 0.1,
    photo: womanSnakeblueTeeFront,
    sliderPhoto: [womanLayoutTeeBack, womanSnakeblueTeeLeft, womanSnakeblueTeeRight],
    sex: 'woman',
    type: 'femei top tricouri',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#0091e5', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'wst2',
  }, wst3: {
    name: 'Tricou snake',
    price: 59.99,
    discount: 0,
    photo: womanSnakecyanTeeFront,
    sliderPhoto: [womanLayoutTeeBack, womanSnakecyanTeeLeft, womanSnakecyanTeeRight],
    sex: 'woman',
    type: 'femei top tricouri',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#00d2ff', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'wst3',
  }, wst4: {
    name: 'Tricou snake',
    price: 94.99,
    discount: 0.2,
    photo: womanSnakegreenTeeFront,
    sliderPhoto: [womanLayoutTeeBack, womanSnakegreenTeeLeft, womanSnakegreenTeeRight],
    sex: 'woman',
    type: 'femei top tricouri',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#72ff00', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'wst4',
  }, wst5: {
    name: 'Tricou snake',
    price: 99.99,
    discount: 0,
    photo: womanSnakeorangeTeeFront,
    sliderPhoto: [womanLayoutTeeBack, womanSnakeorangeTeeLeft, womanSnakeorangeTeeRight],
    sex: 'woman',
    type: 'femei top tricouri',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#fd6500', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'wst5',
  }, wst6: {
    name: 'Tricou snake',
    price: 119.99,
    discount: 0,
    photo: womanSnakepinkTeeFront,
    sliderPhoto: [womanLayoutTeeBack, womanSnakepinkTeeLeft, womanSnakepinkTeeRight],
    sex: 'woman',
    type: 'femei top tricouri',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#ff00f0', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'wst6',
  }, wst7: {
    name: 'Tricou snake',
    price: 69.99,
    discount: 0,
    photo: womanSnakepurpleTeeFront,
    sliderPhoto: [womanLayoutTeeBack, womanSnakepurpleTeeLeft, womanSnakepurpleTeeRight],
    sex: 'woman',
    type: 'femei top tricouri',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#a200ff', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'wst7',
  }, wst8: {
    name: 'Tricou snake',
    price: 94.99,
    discount: 0,
    photo: womanSnakeredTeeFront,
    sliderPhoto: [womanLayoutTeeBack, womanSnakeredTeeLeft, womanSnakeredTeeRight],
    sex: 'woman',
    type: 'femei top tricouri',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#ea0000', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'wst8',
  }, wst9: {
    name: 'Tricou snake',
    price: 99.99,
    discount: 0,
    photo: womanSnaketurqoiseTeeFront,
    sliderPhoto: [womanLayoutTeeBack, womanSnaketurqoiseTeeLeft, womanSnaketurqoiseTeeRight],
    sex: 'woman',
    type: 'femei top tricouri',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#00ffd8', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'wst9',
  }, wst10: {
    name: 'Tricou snake',
    price: 109.99,
    discount: 0,
    photo: womanSnakeyellowTeeFront,
    sliderPhoto: [womanLayoutTeeBack, womanSnakeyellowTeeLeft, womanSnakeyellowTeeRight],
    sex: 'woman',
    type: 'femei top tricouri',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#fff600', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'wst10',
  }, cwo1: {
    name: 'Tricou mască Oni',
    price: 129.99,
    discount: 0,
    photo: womanCollectionOniFront1,
    sliderPhoto: [womanLayoutTeeBack, womanLayoutTeeLeft, womanLayoutTeeRight],
    sex: 'woman',
    type: 'femei top tricouri collection Oni',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#fff600', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'cwo1',
  }, cwo2: {
    name: 'Tricou mască Oni',
    price: 129.99,
    discount: 0,
    photo: womanCollectionOniFront2,
    sliderPhoto: [womanLayoutTeeBack, womanLayoutTeeLeft, womanLayoutTeeRight],
    sex: 'woman',
    type: 'femei top tricouri collection Oni',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#fff600', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'cwo2',
  }, wpb1: {
    name: 'Pantaloni simpli',
    price: 119.99,
    discount: 0.2,
    photo: manblackPanBrownFront,
    sliderPhoto: [manLayoutPanBrownBack],
    sex: 'woman',
    type: 'femei bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#1c1919', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 0, S: 7, M: 6, L: 5, XL: 3, XXL: 0 },
    id: 'wpb1',
  }, wpb2: {
    name: 'Pantaloni simpli',
    price: 119.99,
    discount: 0.2,
    photo: manbluePanBrownFront,
    sliderPhoto: [manLayoutPanBrownBack],
    sex: 'woman',
    type: 'femei bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#0091e5', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 0, S: 7, M: 6, L: 5, XL: 3, XXL: 0 },
    id: 'wpb2',
  }, wpb3: {
    name: 'Pantaloni simpli',
    price: 119.99,
    discount: 0.2,
    photo: mancyanPanBrownFront,
    sliderPhoto: [manLayoutPanBrownBack],
    sex: 'woman',
    type: 'femei bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#00d2ff', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 0, S: 7, M: 6, L: 5, XL: 3, XXL: 0 },
    id: 'wpb3',
  }, wpb4: {
    name: 'Pantaloni simpli',
    price: 119.99,
    discount: 0.2,
    photo: mangreenPanBrownFront,
    sliderPhoto: [manLayoutPanBrownBack],
    sex: 'woman',
    type: 'femei bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#72ff00', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 0, S: 7, M: 6, L: 5, XL: 3, XXL: 0 },
    id: 'wpb4',
  }, wpb5: {
    name: 'Pantaloni simpli',
    price: 119.99,
    discount: 0.2,
    photo: manorangePanBrownFront,
    sliderPhoto: [manLayoutPanBrownBack],
    sex: 'woman',
    type: 'femei bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#fd6500', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 0, S: 7, M: 6, L: 5, XL: 3, XXL: 0 },
    id: 'wpb5',
  }, wpb6: {
    name: 'Pantaloni simpli',
    price: 119.99,
    discount: 0.2,
    photo: manpinkPanBrownFront,
    sliderPhoto: [manLayoutPanBrownBack],
    sex: 'woman',
    type: 'femei bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#ff00f0', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 0, S: 7, M: 6, L: 5, XL: 3, XXL: 0 },
    id: 'wpb6',
  }, wpb7: {
    name: 'Pantaloni simpli',
    price: 119.99,
    discount: 0.2,
    photo: manpurplePanBrownFront,
    sliderPhoto: [manLayoutPanBrownBack],
    sex: 'woman',
    type: 'femei bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#a200ff', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 0, S: 7, M: 6, L: 5, XL: 3, XXL: 0 },
    id: 'wpb7',
  }, wpb8: {
    name: 'Pantaloni simpli',
    price: 119.99,
    discount: 0.2,
    photo: manredPanBrownFront,
    sliderPhoto: [manLayoutPanBrownBack],
    sex: 'woman',
    type: 'femei bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#ea0000', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 0, S: 7, M: 6, L: 5, XL: 3, XXL: 0 },
    id: 'wpb8',
  }, wpb9: {
    name: 'Pantaloni simpli',
    price: 119.99,
    discount: 0.2,
    photo: manturqoisePanBrownFront,
    sliderPhoto: [manLayoutPanBrownBack],
    sex: 'woman',
    type: 'femei bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#00ffd8', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 0, S: 7, M: 6, L: 5, XL: 3, XXL: 0 },
    id: 'wpb9',
  }, wpb10: {
    name: 'Pantaloni simpli',
    price: 119.99,
    discount: 0.2,
    photo: manwhitePanBrownFront,
    sliderPhoto: [manLayoutPanBrownBack],
    sex: 'woman',
    type: 'femei bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#eee', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 0, S: 7, M: 6, L: 5, XL: 3, XXL: 0 },
    id: 'wpb10',
  }, wpb11: {
    name: 'Pantaloni simpli',
    price: 119.99,
    discount: 0.2,
    photo: manyellowPanBrownFront,
    sliderPhoto: [manLayoutPanBrownBack],
    sex: 'woman',
    type: 'femei bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#fff600', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 0, S: 7, M: 6, L: 5, XL: 3, XXL: 0 },
    id: 'wpb11',
  }, wpg1: {
    name: 'Pantaloni simpli',
    price: 119.99,
    discount: 0,
    photo: manblackPanGreyFront,
    sliderPhoto: [manLayoutPanGreyBack],
    sex: 'woman',
    type: 'femei bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#1c1919', '#bdbeb4'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'wpg1',
  }, wpg2: {
    name: 'Pantaloni simpli',
    price: 119.99,
    discount: 0,
    photo: manbluePanGreyFront,
    sliderPhoto: [manLayoutPanGreyBack],
    sex: 'woman',
    type: 'femei bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#0091e5', '#bdbeb4'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'wpg2',
  }, wpg3: {
    name: 'Pantaloni simpli',
    price: 119.99,
    discount: 0,
    photo: mancyanPanGreyFront,
    sliderPhoto: [manLayoutPanGreyBack],
    sex: 'woman',
    type: 'femei bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#00d2ff', '#bdbeb4'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'wpg3',
  }, wpg4: {
    name: 'Pantaloni simpli',
    price: 119.99,
    discount: 0,
    photo: mangreenPanGreyFront,
    sliderPhoto: [manLayoutPanGreyBack],
    sex: 'woman',
    type: 'femei bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#72ff00', '#bdbeb4'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'wpg4',
  }, wpg5: {
    name: 'Pantaloni simpli',
    price: 119.99,
    discount: 0,
    photo: manorangePanGreyFront,
    sliderPhoto: [manLayoutPanGreyBack],
    sex: 'woman',
    type: 'femei bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#fd6500', '#bdbeb4'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'wpg5',
  }, wpg6: {
    name: 'Pantaloni simpli',
    price: 119.99,
    discount: 0,
    photo: manpinkPanGreyFront,
    sliderPhoto: [manLayoutPanGreyBack],
    sex: 'woman',
    type: 'femei bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#ff00f0', '#bdbeb4'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'wpg6',
  }, wpg7: {
    name: 'Pantaloni simpli',
    price: 119.99,
    discount: 0,
    photo: manpurplePanGreyFront,
    sliderPhoto: [manLayoutPanGreyBack],
    sex: 'woman',
    type: 'femei bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#a200ff', '#bdbeb4'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'wpg7',
  }, wpg8: {
    name: 'Pantaloni simpli',
    price: 119.99,
    discount: 0,
    photo: manredPanGreyFront,
    sliderPhoto: [manLayoutPanGreyBack],
    sex: 'woman',
    type: 'femei bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#ea0000', '#bdbeb4'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'wpg8',
  }, wpg9: {
    name: 'Pantaloni simpli',
    price: 119.99,
    discount: 0,
    photo: manturqoisePanGreyFront,
    sliderPhoto: [manLayoutPanGreyBack],
    sex: 'woman',
    type: 'femei bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#00ffd8', '#bdbeb4'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'wpg9',
  }, wpg10: {
    name: 'Pantaloni simpli',
    price: 119.99,
    discount: 0,
    photo: manwhitePanGreyFront,
    sliderPhoto: [manLayoutPanGreyBack],
    sex: 'woman',
    type: 'femei bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#eee', '#bdbeb4'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'wpg10',
  }, wpg11: {
    name: 'Pantaloni simpli',
    price: 119.99,
    discount: 0,
    photo: manyellowPanGreyFront,
    sliderPhoto: [manLayoutPanGreyBack],
    sex: 'woman',
    type: 'femei bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#fff600', '#bdbeb4'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'wpg11',
  }, wpr1: {
    name: 'Pantaloni simpli',
    price: 119.99,
    discount: 0,
    photo: manblackPanRedFront,
    sliderPhoto: [manLayoutPanRedBack],
    sex: 'woman',
    type: 'femei bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#1c1919', '#ea0000'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'wpr1',
  }, wpr2: {
    name: 'Pantaloni simpli',
    price: 119.99,
    discount: 0,
    photo: manbluePanRedFront,
    sliderPhoto: [manLayoutPanRedBack],
    sex: 'woman',
    type: 'femei bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#0091e5', '#ea0000'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'wpr2',
  }, wpr3: {
    name: 'Pantaloni simpli',
    price: 119.99,
    discount: 0,
    photo: mancyanPanRedFront,
    sliderPhoto: [manLayoutPanRedBack],
    sex: 'woman',
    type: 'femei bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#00d2ff', '#ea0000'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'wpr3',
  }, wpr4: {
    name: 'Pantaloni simpli',
    price: 119.99,
    discount: 0,
    photo: mangreenPanRedFront,
    sliderPhoto: [manLayoutPanRedBack],
    sex: 'woman',
    type: 'femei bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#72ff00', '#ea0000'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'wpr4',
  }, wpr5: {
    name: 'Pantaloni simpli',
    price: 119.99,
    discount: 0,
    photo: manorangePanRedFront,
    sliderPhoto: [manLayoutPanRedBack],
    sex: 'woman',
    type: 'femei bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#fd6500', '#ea0000'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'wpr5',
  }, wpr6: {
    name: 'Pantaloni simpli',
    price: 119.99,
    discount: 0,
    photo: manpinkPanRedFront,
    sliderPhoto: [manLayoutPanRedBack],
    sex: 'woman',
    type: 'femei bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#ff00f0', '#ea0000'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'wpr6',
  }, wpr7: {
    name: 'Pantaloni simpli',
    price: 119.99,
    discount: 0,
    photo: manpurplePanRedFront,
    sliderPhoto: [manLayoutPanRedBack],
    sex: 'woman',
    type: 'femei bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#a200ff', '#ea0000'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'wpr7',
  }, wpr8: {
    name: 'Pantaloni simpli',
    price: 119.99,
    discount: 0,
    photo: manredPanRedFront,
    sliderPhoto: [manLayoutPanRedBack],
    sex: 'woman',
    type: 'femei bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#ea0000', '#ea0000'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'wpr8',
  }, wpr9: {
    name: 'Pantaloni simpli',
    price: 119.99,
    discount: 0,
    photo: manturqoisePanRedFront,
    sliderPhoto: [manLayoutPanRedBack],
    sex: 'woman',
    type: 'femei bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#00ffd8', '#ea0000'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'wpr9',
  }, wpr10: {
    name: 'Pantaloni simpli',
    price: 119.99,
    discount: 0,
    photo: manwhitePanRedFront,
    sliderPhoto: [manLayoutPanRedBack],
    sex: 'woman',
    type: 'femei bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#eee', '#ea0000'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'wpr10',
  }, wpr11: {
    name: 'Pantaloni simpli',
    price: 119.99,
    discount: 0,
    photo: manyellowPanRedFront,
    sliderPhoto: [manLayoutPanRedBack],
    sex: 'woman',
    type: 'femei bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#fff600', '#ea0000'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'wpr11',
  }, wpo1: {
    name: 'Pantaloni simpli',
    price: 119.99,
    discount: 0,
    photo: manblackPanOrangeFront,
    sliderPhoto: [manLayoutPanOrangeBack],
    sex: 'woman',
    type: 'femei bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#1c1919', '#fd6500'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'wpo1',
  }, wpo2: {
    name: 'Pantaloni simpli',
    price: 119.99,
    discount: 0,
    photo: manbluePanOrangeFront,
    sliderPhoto: [manLayoutPanOrangeBack],
    sex: 'woman',
    type: 'femei bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#0091e5', '#fd6500'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'wpo2',
  }, wpo3: {
    name: 'Pantaloni simpli',
    price: 119.99,
    discount: 0,
    photo: mancyanPanOrangeFront,
    sliderPhoto: [manLayoutPanOrangeBack],
    sex: 'woman',
    type: 'femei bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#00d2ff', '#fd6500'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'wpo3',
  }, wpo4: {
    name: 'Pantaloni simpli',
    price: 119.99,
    discount: 0,
    photo: mangreenPanOrangeFront,
    sliderPhoto: [manLayoutPanOrangeBack],
    sex: 'woman',
    type: 'femei bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#72ff00', '#fd6500'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'wpo4',
  }, wpo5: {
    name: 'Pantaloni simpli',
    price: 119.99,
    discount: 0,
    photo: manorangePanOrangeFront,
    sliderPhoto: [manLayoutPanOrangeBack],
    sex: 'woman',
    type: 'femei bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#fd6500', '#fd6500'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'wpo5',
  }, wpo6: {
    name: 'Pantaloni simpli',
    price: 119.99,
    discount: 0,
    photo: manpinkPanOrangeFront,
    sliderPhoto: [manLayoutPanOrangeBack],
    sex: 'woman',
    type: 'femei bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#ff00f0', '#fd6500'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'wpo6',
  }, wpo7: {
    name: 'Pantaloni simpli',
    price: 119.99,
    discount: 0,
    photo: manpurplePanOrangeFront,
    sliderPhoto: [manLayoutPanOrangeBack],
    sex: 'woman',
    type: 'femei bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#a200ff', '#fd6500'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'wpo7',
  }, wpo8: {
    name: 'Pantaloni simpli',
    price: 119.99,
    discount: 0,
    photo: manredPanOrangeFront,
    sliderPhoto: [manLayoutPanOrangeBack],
    sex: 'woman',
    type: 'femei bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#ea0000', '#fd6500'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'wpo8',
  }, wpo9: {
    name: 'Pantaloni simpli',
    price: 119.99,
    discount: 0,
    photo: manturqoisePanOrangeFront,
    sliderPhoto: [manLayoutPanOrangeBack],
    sex: 'woman',
    type: 'femei bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#00ffd8', '#fd6500'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'wpo9',
  }, wpo10: {
    name: 'Pantaloni simpli',
    price: 119.99,
    discount: 0,
    photo: manwhitePanOrangeFront,
    sliderPhoto: [manLayoutPanOrangeBack],
    sex: 'woman',
    type: 'femei bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#eee', '#fd6500'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'wpo10',
  }, wpo11: {
    name: 'Pantaloni simpli',
    price: 119.99,
    discount: 0,
    photo: manyellowPanOrangeFront,
    sliderPhoto: [manLayoutPanOrangeBack],
    sex: 'woman',
    type: 'femei bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#fff600', '#fd6500'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'wpo11',
  },
}
export const Product2 = {
  wpsb1: {
    name: 'Pantaloni Snake',
    price: 119.99,
    discount: 0.2,
    photo: manSnakeblackPanBrownFront,
    sliderPhoto: [manLayoutPanBrownBack],
    sex: 'woman',
    type: 'femei bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#1c1919', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 0, S: 7, M: 6, L: 5, XL: 3, XXL: 0 },
    id: 'wpsb1',
  }, wpsb2: {
    name: 'Pantaloni Snake',
    price: 119.99,
    discount: 0.2,
    photo: manSnakebluePanBrownFront,
    sliderPhoto: [manLayoutPanBrownBack],
    sex: 'woman',
    type: 'femei bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#0091e5', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 0, S: 7, M: 6, L: 5, XL: 3, XXL: 0 },
    id: 'wpsb2',
  }, wpsb3: {
    name: 'Pantaloni Snake',
    price: 119.99,
    discount: 0.2,
    photo: manSnakecyanPanBrownFront,
    sliderPhoto: [manLayoutPanBrownBack],
    sex: 'woman',
    type: 'femei bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#00d2ff', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 0, S: 7, M: 6, L: 5, XL: 3, XXL: 0 },
    id: 'wpsb3',
  }, wpsb4: {
    name: 'Pantaloni Snake',
    price: 119.99,
    discount: 0.2,
    photo: manSnakegreenPanBrownFront,
    sliderPhoto: [manLayoutPanBrownBack],
    sex: 'woman',
    type: 'femei bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#72ff00', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 0, S: 7, M: 6, L: 5, XL: 3, XXL: 0 },
    id: 'wpsb4',
  }, wpsb5: {
    name: 'Pantaloni Snake',
    price: 119.99,
    discount: 0.2,
    photo: manSnakeorangePanBrownFront,
    sliderPhoto: [manLayoutPanBrownBack],
    sex: 'woman',
    type: 'femei bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#fd6500', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 0, S: 7, M: 6, L: 5, XL: 3, XXL: 0 },
    id: 'wpsb5',
  }, wpsb6: {
    name: 'Pantaloni Snake',
    price: 119.99,
    discount: 0.2,
    photo: manSnakepinkPanBrownFront,
    sliderPhoto: [manLayoutPanBrownBack],
    sex: 'woman',
    type: 'femei bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#ff00f0', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 0, S: 7, M: 6, L: 5, XL: 3, XXL: 0 },
    id: 'wpsb6',
  }, wpsb7: {
    name: 'Pantaloni Snake',
    price: 119.99,
    discount: 0.2,
    photo: manSnakepurplePanBrownFront,
    sliderPhoto: [manLayoutPanBrownBack],
    sex: 'woman',
    type: 'femei bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#a200ff', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 0, S: 7, M: 6, L: 5, XL: 3, XXL: 0 },
    id: 'wpsb7',
  }, wpsb8: {
    name: 'Pantaloni Snake',
    price: 119.99,
    discount: 0.2,
    photo: manSnakeredPanBrownFront,
    sliderPhoto: [manLayoutPanBrownBack],
    sex: 'woman',
    type: 'femei bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#ea0000', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 0, S: 7, M: 6, L: 5, XL: 3, XXL: 0 },
    id: 'wpsb8',
  }, wpsb9: {
    name: 'Pantaloni Snake',
    price: 119.99,
    discount: 0.2,
    photo: manSnaketurqoisePanBrownFront,
    sliderPhoto: [manLayoutPanBrownBack],
    sex: 'woman',
    type: 'femei bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#00ffd8', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 0, S: 7, M: 6, L: 5, XL: 3, XXL: 0 },
    id: 'wpsb9',
  }, wpsb10: {
    name: 'Pantaloni Snake',
    price: 119.99,
    discount: 0.2,
    photo: manSnakewhitePanBrownFront,
    sliderPhoto: [manLayoutPanBrownBack],
    sex: 'woman',
    type: 'femei bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#eee', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 0, S: 7, M: 6, L: 5, XL: 3, XXL: 0 },
    id: 'wpsb10',
  }, wpsb11: {
    name: 'Pantaloni Snake',
    price: 119.99,
    discount: 0.2,
    photo: manSnakeyellowPanBrownFront,
    sliderPhoto: [manLayoutPanBrownBack],
    sex: 'woman',
    type: 'femei bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#fff600', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 0, S: 7, M: 6, L: 5, XL: 3, XXL: 0 },
    id: 'wpsb11',
  }, wpsg1: {
    name: 'Pantaloni Snake',
    price: 119.99,
    discount: 0,
    photo: manSnakeblackPanGreyFront,
    sliderPhoto: [manLayoutPanGreyBack],
    sex: 'woman',
    type: 'femei bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#1c1919', '#bdbeb4'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'wpsg1',
  }, wpsg2: {
    name: 'Pantaloni Snake',
    price: 119.99,
    discount: 0,
    photo: manSnakebluePanGreyFront,
    sliderPhoto: [manLayoutPanGreyBack],
    sex: 'woman',
    type: 'femei bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#0091e5', '#bdbeb4'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'wpsg2',
  }, wpsg3: {
    name: 'Pantaloni Snake',
    price: 119.99,
    discount: 0,
    photo: manSnakecyanPanGreyFront,
    sliderPhoto: [manLayoutPanGreyBack],
    sex: 'woman',
    type: 'femei bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#00d2ff', '#bdbeb4'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'wpsg3',
  }, wpsg4: {
    name: 'Pantaloni Snake',
    price: 119.99,
    discount: 0,
    photo: manSnakegreenPanGreyFront,
    sliderPhoto: [manLayoutPanGreyBack],
    sex: 'woman',
    type: 'femei bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#72ff00', '#bdbeb4'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'wpsg4',
  }, wpsg5: {
    name: 'Pantaloni Snake',
    price: 119.99,
    discount: 0,
    photo: manSnakeorangePanGreyFront,
    sliderPhoto: [manLayoutPanGreyBack],
    sex: 'woman',
    type: 'femei bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#fd6500', '#bdbeb4'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'wpsg5',
  }, wpsg6: {
    name: 'Pantaloni Snake',
    price: 119.99,
    discount: 0,
    photo: manSnakepinkPanGreyFront,
    sliderPhoto: [manLayoutPanGreyBack],
    sex: 'woman',
    type: 'femei bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#ff00f0', '#bdbeb4'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'wpsg6',
  }, wpsg7: {
    name: 'Pantaloni Snake',
    price: 119.99,
    discount: 0,
    photo: manSnakepurplePanGreyFront,
    sliderPhoto: [manLayoutPanGreyBack],
    sex: 'woman',
    type: 'femei bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#a200ff', '#bdbeb4'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'wpsg7',
  }, wpsg8: {
    name: 'Pantaloni Snake',
    price: 119.99,
    discount: 0,
    photo: manSnakeredPanGreyFront,
    sliderPhoto: [manLayoutPanGreyBack],
    sex: 'woman',
    type: 'femei bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#ea0000', '#bdbeb4'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'wpsg8',
  }, wpsg9: {
    name: 'Pantaloni Snake',
    price: 119.99,
    discount: 0,
    photo: manSnaketurqoisePanGreyFront,
    sliderPhoto: [manLayoutPanGreyBack],
    sex: 'woman',
    type: 'femei bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#00ffd8', '#bdbeb4'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'wpsg9',
  }, wpsg10: {
    name: 'Pantaloni Snake',
    price: 119.99,
    discount: 0,
    photo: manSnakewhitePanGreyFront,
    sliderPhoto: [manLayoutPanGreyBack],
    sex: 'woman',
    type: 'femei bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#eee', '#bdbeb4'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'wpsg10',
  }, wpsg11: {
    name: 'Pantaloni Snake',
    price: 119.99,
    discount: 0,
    photo: manSnakeyellowPanGreyFront,
    sliderPhoto: [manLayoutPanGreyBack],
    sex: 'woman',
    type: 'femei bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#fff600', '#bdbeb4'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'wpsg11',
  }, wpsr1: {
    name: 'Pantaloni Snake',
    price: 119.99,
    discount: 0,
    photo: manSnakeblackPanRedFront,
    sliderPhoto: [manLayoutPanRedBack],
    sex: 'woman',
    type: 'femei bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#1c1919', '#ea0000'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'wpsr1',
  }, wpsr2: {
    name: 'Pantaloni Snake',
    price: 119.99,
    discount: 0,
    photo: manSnakebluePanRedFront,
    sliderPhoto: [manLayoutPanRedBack],
    sex: 'woman',
    type: 'femei bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#0091e5', '#ea0000'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'wpsr2',
  }, wpsr3: {
    name: 'Pantaloni Snake',
    price: 119.99,
    discount: 0,
    photo: manSnakecyanPanRedFront,
    sliderPhoto: [manLayoutPanRedBack],
    sex: 'woman',
    type: 'femei bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#00d2ff', '#ea0000'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'wpsr3',
  }, wpsr4: {
    name: 'Pantaloni Snake',
    price: 119.99,
    discount: 0,
    photo: manSnakegreenPanRedFront,
    sliderPhoto: [manLayoutPanRedBack],
    sex: 'woman',
    type: 'femei bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#72ff00', '#ea0000'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'wpsr4',
  }, wpsr5: {
    name: 'Pantaloni Snake',
    price: 119.99,
    discount: 0,
    photo: manSnakeorangePanRedFront,
    sliderPhoto: [manLayoutPanRedBack],
    sex: 'woman',
    type: 'femei bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#fd6500', '#ea0000'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'wpsr5',
  }, wpsr6: {
    name: 'Pantaloni Snake',
    price: 119.99,
    discount: 0,
    photo: manSnakepinkPanRedFront,
    sliderPhoto: [manLayoutPanRedBack],
    sex: 'woman',
    type: 'femei bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#ff00f0', '#ea0000'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'wpsr6',
  }, wpsr7: {
    name: 'Pantaloni Snake',
    price: 119.99,
    discount: 0,
    photo: manSnakepurplePanRedFront,
    sliderPhoto: [manLayoutPanRedBack],
    sex: 'woman',
    type: 'femei bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#a200ff', '#ea0000'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'wpsr7',
  }, wpsr8: {
    name: 'Pantaloni Snake',
    price: 119.99,
    discount: 0,
    photo: manSnakeredPanRedFront,
    sliderPhoto: [manLayoutPanRedBack],
    sex: 'woman',
    type: 'femei bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#ea0000', '#ea0000'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'wpsr8',
  }, wpsr9: {
    name: 'Pantaloni Snake',
    price: 119.99,
    discount: 0,
    photo: manSnaketurqoisePanRedFront,
    sliderPhoto: [manLayoutPanRedBack],
    sex: 'woman',
    type: 'femei bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#00ffd8', '#ea0000'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'wpsr9',
  }, wpsr10: {
    name: 'Pantaloni Snake',
    price: 119.99,
    discount: 0,
    photo: manSnakewhitePanRedFront,
    sliderPhoto: [manLayoutPanRedBack],
    sex: 'woman',
    type: 'femei bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#eee', '#ea0000'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'wpsr10',
  }, wpsr11: {
    name: 'Pantaloni Snake',
    price: 119.99,
    discount: 0,
    photo: manSnakeyellowPanRedFront,
    sliderPhoto: [manLayoutPanRedBack],
    sex: 'woman',
    type: 'femei bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#fff600', '#ea0000'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'wpsr11',
  }, wpso1: {
    name: 'Pantaloni Snake',
    price: 119.99,
    discount: 0,
    photo: manSnakeblackPanOrangeFront,
    sliderPhoto: [manLayoutPanOrangeBack],
    sex: 'woman',
    type: 'femei bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#1c1919', '#fd6500'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'wpso1',
  }, wpso2: {
    name: 'Pantaloni Snake',
    price: 119.99,
    discount: 0,
    photo: manSnakebluePanOrangeFront,
    sliderPhoto: [manLayoutPanOrangeBack],
    sex: 'woman',
    type: 'femei bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#0091e5', '#fd6500'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'wpso2',
  }, wpso3: {
    name: 'Pantaloni Snake',
    price: 119.99,
    discount: 0,
    photo: manSnakecyanPanOrangeFront,
    sliderPhoto: [manLayoutPanOrangeBack],
    sex: 'woman',
    type: 'femei bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#00d2ff', '#fd6500'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'wpso3',
  }, wpso4: {
    name: 'Pantaloni Snake',
    price: 119.99,
    discount: 0,
    photo: manSnakegreenPanOrangeFront,
    sliderPhoto: [manLayoutPanOrangeBack],
    sex: 'woman',
    type: 'femei bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#72ff00', '#fd6500'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'wpso4',
  }, wpso5: {
    name: 'Pantaloni Snake',
    price: 119.99,
    discount: 0,
    photo: manSnakeorangePanOrangeFront,
    sliderPhoto: [manLayoutPanOrangeBack],
    sex: 'woman',
    type: 'femei bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#fd6500', '#fd6500'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'wpso5',
  }, wpso6: {
    name: 'Pantaloni Snake',
    price: 119.99,
    discount: 0,
    photo: manSnakepinkPanOrangeFront,
    sliderPhoto: [manLayoutPanOrangeBack],
    sex: 'woman',
    type: 'femei bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#ff00f0', '#fd6500'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'wpso6',
  }, wpso7: {
    name: 'Pantaloni Snake',
    price: 119.99,
    discount: 0,
    photo: manSnakepurplePanOrangeFront,
    sliderPhoto: [manLayoutPanOrangeBack],
    sex: 'woman',
    type: 'femei bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#a200ff', '#fd6500'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'wpso7',
  }, wpso8: {
    name: 'Pantaloni Snake',
    price: 119.99,
    discount: 0,
    photo: manSnakeredPanOrangeFront,
    sliderPhoto: [manLayoutPanOrangeBack],
    sex: 'woman',
    type: 'femei bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#ea0000', '#fd6500'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'wpso8',
  }, wpso9: {
    name: 'Pantaloni Snake',
    price: 119.99,
    discount: 0,
    photo: manSnaketurqoisePanOrangeFront,
    sliderPhoto: [manLayoutPanOrangeBack],
    sex: 'woman',
    type: 'femei bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#00ffd8', '#fd6500'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'wpso9',
  }, wpso10: {
    name: 'Pantaloni Snake',
    price: 119.99,
    discount: 0,
    photo: manSnakewhitePanOrangeFront,
    sliderPhoto: [manLayoutPanOrangeBack],
    sex: 'woman',
    type: 'femei bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#eee', '#fd6500'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'wpso10',
  }, wpso11: {
    name: 'Pantaloni Snake',
    price: 119.99,
    discount: 0,
    photo: manSnakeyellowPanOrangeFront,
    sliderPhoto: [manLayoutPanOrangeBack],
    sex: 'woman',
    type: 'femei bottom lungi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#fff600', '#fd6500'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'wpso11',
  }, msd1: {
    name: 'Adidași simpli',
    price: 119.99,
    discount: 0,
    photo: manShoblueFront,
    sliderPhoto: [],
    sex: 'man',
    type: 'barbati foot adidasi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#0091e5', '#1c1919'],
    star: { total: 0, nr: 0 },
    size: { 37: 4, 38: 9, 39: 5, 40: 3, 41: 6, 42: 10, 43: 0, 44: 0 },
    id: 'msd1',
  }, msd2: {
    name: 'Adidași simpli',
    price: 119.99,
    discount: 0,
    photo: manShogreenFront,
    sliderPhoto: [],
    sex: 'man',
    type: 'barbati foot adidasi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#72ff00', '#1c1919'],
    star: { total: 0, nr: 0 },
    size: { 37: 4, 38: 9, 39: 5, 40: 3, 41: 6, 42: 10, 43: 0, 44: 0 },
    id: 'msd2',
  }, msd3: {
    name: 'Adidași simpli',
    price: 119.99,
    discount: 0,
    photo: manShoorangeFront,
    sliderPhoto: [],
    sex: 'man',
    type: 'barbati foot adidasi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#fd7500', '#1c1919'],
    star: { total: 0, nr: 0 },
    size: { 37: 4, 38: 9, 39: 5, 40: 3, 41: 6, 42: 10, 43: 0, 44: 0 },
    id: 'msd3',
  }, msd4: {
    name: 'Adidași simpli',
    price: 119.99,
    discount: 0,
    photo: manShopinkFront,
    sliderPhoto: [],
    sex: 'man',
    type: 'barbati foot adidasi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#ff00f0', '#1c1919'],
    star: { total: 0, nr: 0 },
    size: { 37: 4, 38: 9, 39: 5, 40: 3, 41: 6, 42: 10, 43: 0, 44: 0 },
    id: 'msd4',
  }, msd5: {
    name: 'Adidași simpli',
    price: 119.99,
    discount: 0,
    photo: manShoredFront,
    sliderPhoto: [],
    sex: 'man',
    type: 'barbati foot adidasi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#ea0000', '#1c1919'],
    star: { total: 0, nr: 0 },
    size: { 37: 4, 38: 9, 39: 5, 40: 3, 41: 6, 42: 10, 43: 0, 44: 0 },
    id: 'msd5',
  }, msd6: {
    name: 'Adidași simpli',
    price: 119.99,
    discount: 0,
    photo: manShowhiteFront,
    sliderPhoto: [],
    sex: 'man',
    type: 'barbati foot adidasi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#1c1919', '#eee'],
    star: { total: 0, nr: 0 },
    size: { 37: 4, 38: 9, 39: 5, 40: 3, 41: 6, 42: 10, 43: 0, 44: 0 },
    id: 'msd6',
  }, msd7: {
    name: 'Adidași simpli',
    price: 119.99,
    discount: 0,
    photo: manShoyellowFront,
    sliderPhoto: [],
    sex: 'man',
    type: 'barbati foot adidasi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#fff600', '#1c1919'],
    star: { total: 0, nr: 0 },
    size: { 37: 4, 38: 9, 39: 5, 40: 3, 41: 6, 42: 10, 43: 0, 44: 0 },
    id: 'msd7',
  }, wsd1: {
    name: 'Adidași simpli',
    price: 119.99,
    discount: 0,
    photo: womanShoblueFront,
    sliderPhoto: [],
    sex: 'woman',
    type: 'femei foot adidasi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#1c1919', '#0091e5'],
    star: { total: 0, nr: 0 },
    size: { 37: 4, 38: 9, 39: 5, 40: 3, 41: 6, 42: 10, 43: 0, 44: 0 },
    id: 'wsd1',
  }, wsd2: {
    name: 'Adidași simpli',
    price: 119.99,
    discount: 0,
    photo: womanShogreenFront,
    sliderPhoto: [],
    sex: 'woman',
    type: 'femei foot adidasi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#72ff00', '#1c1919'],
    star: { total: 0, nr: 0 },
    size: { 37: 4, 38: 9, 39: 5, 40: 3, 41: 6, 42: 10, 43: 0, 44: 0 },
    id: 'wsd2',
  }, wsd3: {
    name: 'Adidași simpli',
    price: 119.99,
    discount: 0,
    photo: womanShoorangeFront,
    sliderPhoto: [],
    sex: 'woman',
    type: 'femei foot adidasi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#fd6500', '#1c1919'],
    star: { total: 0, nr: 0 },
    size: { 37: 4, 38: 9, 39: 5, 40: 3, 41: 6, 42: 10, 43: 0, 44: 0 },
    id: 'wsd3',
  }, wsd4: {
    name: 'Adidași simpli',
    price: 119.99,
    discount: 0,
    photo: womanShopinkFront,
    sliderPhoto: [],
    sex: 'woman',
    type: 'femei foot adidasi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#ff00f0', '#1c1919'],
    star: { total: 0, nr: 0 },
    size: { 37: 4, 38: 9, 39: 5, 40: 3, 41: 6, 42: 10, 43: 0, 44: 0 },
    id: 'wsd4',
  }, wsd5: {
    name: 'Adidași simpli',
    price: 119.99,
    discount: 0,
    photo: womanShoredFront,
    sliderPhoto: [],
    sex: 'woman',
    type: 'femei foot adidasi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#ea0000', '#1c1919'],
    star: { total: 0, nr: 0 },
    size: { 37: 4, 38: 9, 39: 5, 40: 3, 41: 6, 42: 10, 43: 0, 44: 0 },
    id: 'wsd5',
  }, wsd6: {
    name: 'Adidași simpli',
    price: 119.99,
    discount: 0,
    photo: womanShowhiteFront,
    sliderPhoto: [],
    sex: 'woman',
    type: 'femei foot adidasi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#1c1919', '#eee'],
    star: { total: 0, nr: 0 },
    size: { 37: 4, 38: 9, 39: 5, 40: 3, 41: 6, 42: 10, 43: 0, 44: 0 },
    id: 'wsd6',
  }, wsd7: {
    name: 'Adidași simpli',
    price: 119.99,
    discount: 0,
    photo: womanShoyellowFront,
    sliderPhoto: [],
    sex: 'woman',
    type: 'femei foot adidasi',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#fff600', '#1c1919'],
    star: { total: 0, nr: 0 },
    size: { 37: 4, 38: 9, 39: 5, 40: 3, 41: 6, 42: 10, 43: 0, 44: 0 },
    id: 'wsd7',
  }, msld1: {
    name: 'Papuci simpli',
    price: 119.99,
    discount: 0,
    photo: manSliwhiteFront,
    sliderPhoto: [],
    sex: 'man',
    type: 'barbati foot papuci',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#1c1919', '#eee'],
    star: { total: 0, nr: 0 },
    size: { 37: 4, 38: 9, 39: 5, 40: 3, 41: 6, 42: 10, 43: 0, 44: 0 },
    id: 'msld1',
  }, wsld1: {
    name: 'Papuci simpli',
    price: 119.99,
    discount: 0,
    photo: womanSliwhiteFront,
    sliderPhoto: [],
    sex: 'woman',
    type: 'femei foot papuci',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#eee', '#1c1919'],
    star: { total: 0, nr: 0 },
    size: { 37: 4, 38: 9, 39: 5, 40: 3, 41: 6, 42: 10, 43: 0, 44: 0 },
    id: 'wsld1',
  }, whd1: {
    name: 'Hanorac simplu',
    price: 99.99,
    discount: 0,
    photo: blueHooFront,
    sliderPhoto: [blueHooBack, blueHooLeft, blueHooRight],
    sex: 'woman',
    type: 'femei top bluze',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#0091e5', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 4, S: 5, M: 5, L: 6, XL: 7, XXL: 6 },
    id: 'whd1',
  }, whd2: {
    name: 'Hanorac simplu',
    price: 79.99,
    discount: 0,
    photo: cyanHooFront,
    sliderPhoto: [cyanHooBack, cyanHooLeft, cyanHooRight],
    sex: 'woman',
    type: 'femei top bluze',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#00d2ff', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 4, S: 7, M: 9, L: 1, XL: 7, XXL: 0 },
    id: 'whd2',
  }, whd3: {
    name: 'Hanorac simplu',
    price: 109.99,
    discount: 0,
    photo: greenHooFront,
    sliderPhoto: [greenHooBack, greenHooLeft, greenHooRight],
    sex: 'woman',
    type: 'femei top bluze',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#72ff00', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 4, S: 5, M: 6, L: 0, XL: 7, XXL: 0 },
    id: 'whd3',
  }, whd4: {
    name: 'Hanorac simplu',
    price: 139.99,
    discount: 0.3,
    photo: orangeHooFront,
    sliderPhoto: [orangeHooBack, orangeHooLeft, orangeHooRight],
    sex: 'woman',
    type: 'femei top bluze',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#fd6500', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 6, S: 6, M: 14, L: 15, XL: 21, XXL: 23 },
    id: 'whd4',
  }, whd5: {
    name: 'Hanorac simplu',
    price: 99.99,
    discount: 0.2,
    photo: pinkHooFront,
    sliderPhoto: [pinkHooBack, pinkHooLeft, pinkHooRight],
    sex: 'woman',
    type: 'femei top bluze',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#ff00f0', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 5, S: 5, M: 3, L: 0, XL: 2, XXL: 6 },
    id: 'whd5',
  }, whd6: {
    name: 'Hanorac simplu',
    price: 79.99,
    discount: 0,
    photo: purpleHooFront,
    sliderPhoto: [purpleHooBack, purpleHooLeft, purpleHooRight],
    sex: 'woman',
    type: 'femei top bluze',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#a200ff', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 0, S: 0, M: 4, L: 2, XL: 7, XXL: 3 },
    id: 'whd6',
  }, whd7: {
    name: 'Hanorac simplu',
    price: 94.99,
    discount: 0,
    photo: redHooFront,
    sliderPhoto: [redHooBack, redHooLeft, redHooRight],
    sex: 'woman',
    type: 'femei top bluze',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#ea0000', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 4, S: 6, M: 3, L: 7, XL: 7, XXL: 3 },
    id: 'whd7',
  }, whd8: {
    name: 'Hanorac simplu',
    price: 59.99,
    discount: 0,
    photo: turqoiseHooFront,
    sliderPhoto: [turqoiseHooBack, turqoiseHooLeft, turqoiseHooRight],
    sex: 'woman',
    type: 'femei top bluze',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#00ffd8', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 6, S: 3, M: 0, L: 9, XL: 11, XXL: 21 },
    id: 'whd8',
  }, whd9: {
    name: 'Hanorac simplu',
    price: 69.99,
    discount: 0,
    photo: blackHooFront,
    sliderPhoto: [blackHooBack, blackHooLeft, blackHooRight],
    sex: 'woman',
    type: 'femei top bluze',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#1c1919', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 6, S: 2, M: 4, L: 3, XL: 0, XXL: 0 },
    id: 'whd9',
  }, whd10: {
    name: 'Hanorac simplu',
    price: 119.99,
    discount: 0.2,
    photo: yellowHooFront,
    sliderPhoto: [yellowHooBack, yellowHooLeft, yellowHooRight],
    sex: 'woman',
    type: 'femei top bluze',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#ffd600', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 0, S: 7, M: 6, L: 5, XL: 3, XXL: 0 },
    id: 'whd10',
  }, wds1: {
    name: 'Pantaloni scurți simpli',
    price: 119.99,
    discount: 0,
    photo: manblackShoFront,
    sliderPhoto: [manLayoutShoBack, manLayoutShoLeft, manLayoutShoRight],
    sex: 'woman',
    type: 'femei bottom scurti',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#1c1919', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'wds1',
  }, wds2: {
    name: 'Pantaloni scurți simpli',
    price: 119.99,
    discount: 0,
    photo: manblueShoFront,
    sliderPhoto: [manLayoutShoBack, manLayoutShoLeft, manLayoutShoRight],
    sex: 'woman',
    type: 'femei bottom scurti',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#0091e5', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'wds2',
  }, wds3: {
    name: 'Pantaloni scurți simpli',
    price: 119.99,
    discount: 0,
    photo: mancyanShoFront,
    sliderPhoto: [manLayoutShoBack, manLayoutShoLeft, manLayoutShoRight],
    sex: 'woman',
    type: 'femei bottom scurti',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#00d2ff', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'wds3',
  }, wds4: {
    name: 'Pantaloni scurți simpli',
    price: 119.99,
    discount: 0,
    photo: mangreenShoFront,
    sliderPhoto: [manLayoutShoBack, manLayoutShoLeft, manLayoutShoRight],
    sex: 'woman',
    type: 'femei bottom scurti',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#72ff00', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'wds4',
  }, wds5: {
    name: 'Pantaloni scurți simpli',
    price: 119.99,
    discount: 0,
    photo: manorangeShoFront,
    sliderPhoto: [manLayoutShoBack, manLayoutShoLeft, manLayoutShoRight],
    sex: 'woman',
    type: 'femei bottom scurti',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#fd6500', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'wds5',
  }, wds6: {
    name: 'Pantaloni scurți simpli',
    price: 119.99,
    discount: 0,
    photo: manpinkShoFront,
    sliderPhoto: [manLayoutShoBack, manLayoutShoLeft, manLayoutShoRight],
    sex: 'woman',
    type: 'femei bottom scurti',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#ff00f0', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'wds6',
  }, wds7: {
    name: 'Pantaloni scurți simpli',
    price: 119.99,
    discount: 0,
    photo: manpurpleShoFront,
    sliderPhoto: [manLayoutShoBack, manLayoutShoLeft, manLayoutShoRight],
    sex: 'woman',
    type: 'femei bottom scurti',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#a200ff', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'wds7',
  }, wds8: {
    name: 'Pantaloni scurți simpli',
    price: 119.99,
    discount: 0,
    photo: manredShoFront,
    sliderPhoto: [manLayoutShoBack, manLayoutShoLeft, manLayoutShoRight],
    sex: 'woman',
    type: 'femei bottom scurti',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#ea0000', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'wds8',
  }, wds9: {
    name: 'Pantaloni scurți simpli',
    price: 119.99,
    discount: 0,
    photo: manturqoiseShoFront,
    sliderPhoto: [manLayoutShoBack, manLayoutShoLeft, manLayoutShoRight],
    sex: 'woman',
    type: 'femei bottom scurti',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#00ffd8', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'wds9',
  }, wds10: {
    name: 'Pantaloni scurți simpli',
    price: 119.99,
    discount: 0,
    photo: manyellowShoFront,
    sliderPhoto: [manLayoutShoBack, manLayoutShoLeft, manLayoutShoRight],
    sex: 'woman',
    type: 'femei bottom scurti',
    spec: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut diam quam nulla porttitor massa. Purus sit amet luctus venenatis. Turpis egestas integer eget aliquet nibh praesent tristique. Laoreet id donec ultrices tincidunt arcu non sodales neque.',
    colors: ['#fff600', '#eee'],
    star: { total: 0, nr: 0 },
    size: { XS: 3, S: 7, M: 6, L: 5, XL: 3, XXL: 1 },
    id: 'wds10',
  },
}




export const colors = ['#1c1919', '#bdbeb4', '#eee', '#0091e5', '#00ffd8', '#00d2ff', '#72ff00', '#ff00f0', '#a200ff', '#fd6500', '#fff600', '#ea0000']

export const counties = [
  'Alba',
  'Arad',
  'Argeș',
  'Bacău',
  'Bihor',
  'Bistrița-Năsăud',
  'Botoșani',
  'Brăila',
  'Brașov',
  'București',
  'Buzău',
  'Călărași',
  'Caraș-Severin',
  'Cluj',
  'Constanța',
  'Covasna',
  'Dâmbovița',
  'Dolj',
  'Galați',
  'Giurgiu',
  'Gorj',
  'Harghita',
  'Hunedoara',
  'Ialomița',
  'Iași',
  'Ilfov',
  'Maramureș',
  'Mehedinți',
  'Mureș',
  'Neamț',
  'Olt',
  'Prahova',
  'Sălaj',
  'Satu Mare',
  'Sibiu',
  'Suceava',
  'Teleorman',
  'Timiș',
  'Tulcea',
  'Vâlcea',
  'Vaslui',
  'Vrancea'
];

export const validPath = ['barbati', 'femei', 'barbati top tricouri', 'barbati top bluze', 'barbati bottom scurti', 'barbati bottom lungi',
  'barbati foot adidasi', 'barbati foot papuci', 'barbati top', 'barbati bottom', 'barbati foot',
  'femei top tricouri', 'femei top bluze', 'femei bottom scurti', 'femei bottom lungi',
  'femei foot adidasi', 'femei foot papuci', 'femei top', 'femei bottom', 'femei foot',
  'collection'
]